<template>
  <div>
    <div class="textContainerCenter">
      <title class="cardTitleType1" style="width: 100%; display: flex; flex-direction: row; justify-content: center; font-weight:bold; font-size: 30px;">REPORT ON ONSITE ASSESSMENT</title>
    </div>
    <div class="cardA4">
      <div class="cardContent">
        <p class="cardTitleType1" style="font-weight:bold; font-size: 25px;">1. Company Information</p>
        <el-form-item style="font-size: 16 px; font-style: italic; text-align: justify;" label=""></el-form-item>
      </div>
        <div class="cardOrganiser">
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Company Name</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.companyname }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Company Address</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.companyaddress }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Factory Address</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.factoryaddress }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Year Of Establishment</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.establishmentyear }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Contact Person</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.contactpersonname }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Contact Person's Position</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.contactpersonposition }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Mobile Phone</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.handphone }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Company's Telephone</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.telephone }}</p>
            </div>
          </div>
          <!-- <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Fax</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.fax }}</p>
            </div>
          </div> -->
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Email</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.email }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Company's Website</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.website }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Main Product</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.main_product_name }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Total Employees</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.employee }}</p>
            </div>
          </div>
          <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-around;">
            <div class="columnmxw w20">
              <p class="ptaginvis">Estimated Average Annual Revenue (RM)</p>
            </div>
            <div class="columnmxw w60">
              <p class="ptaginvis">{{ registerForm.averageannualrevenue_productionfocus }}</p>
            </div>
          </div>
        </div>
    </div>
    <div class="cardA4">
      <div class="cardBody">
        <div class="cardContent">
          <div class="cardOrganiser">
            <p class="cardTitleType1" style="font-weight: bold; font-size: 25px; padding-top: 40px;">2. Overall Assessment Summary</p>
          </div>
          <div class="cardOrganiser">
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #929DCF; border-color: rgb(210, 220, 235); color: rgb(39, 62, 149);">
                <span style="font-size: 18px; margin-bottom: 20px; color: #FFFCF5; text-align: center;">TOTAL MARKS</span> 
                <span style="font-size: 48px; color: #FFFCF5;">{{ registerForm.assessorAssessmentDimensionResults.dimensionResultScore | formatRound }} % </span> 
                <span style="font-size: 14px; margin-bottom: 20px; color: #FFFCF5; text-align: center;">{{ registerForm.assessorAssessmentReadinessProfile && registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle ? registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle : 0 }}</span> 
                <span style="font-size: 10px; white-space: pre-line; text-align: center;">
                </span>
              </div> 
            </div>
          </div>
          <div class="cardOrganiser">
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #FFFCF5; border-color: #ebd8d2; color: rgb(39, 62, 149);">
                <span style="font-size: 18px; margin-bottom: 20px; color: #121140; text-align: center;">HIGHLIGHTS</span> 
                <span style="font-size: 48px; color: #121140;">{{ checkedHighlightsCount }}</span> 
                <!-- <a class="navlink" style="font-size: 14px; margin-bottom: 20px; text-align: center;" href="#OSFA">Refer here</a>  -->
                <span style="font-size: 10px; white-space: pre-line; text-align: center;">
                </span>
              </div> 
            </div>
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #fff4e3; border-color: #e8d2c2; color: rgb(191, 118, 28);">
                <span style="font-size: 18px; margin-bottom: 20px; color: #121140; text-align: center;">RECOMMENDATIONS</span> 
                <span style="font-size: 48px; color: #121140">{{ registerForm.assessorRecommendations.length }}</span> 
                <!-- <a class="navlink" style="font-size: 14px; margin-bottom: 20px; text-align: center;" href="#recommendations">Refer here</a>  -->
                <span style="font-size: 10px; white-space: pre-line; text-align: center;"></span>
              </div> 
            </div>
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #e8f1f8; border-color: #abbae0; color: rgb(32, 149, 109);">
                <span style="font-size: 18px; margin-bottom: 20px; color: #121140; text-align: center;">AREAS OF IMPROVEMENTS</span> 
                <span style="font-size: 48px;color: #121140">{{ checkedLowlightsCount }}</span> 
                <!-- <a class="navlink" style="font-size: 14px; margin-bottom: 20px; text-align: center;" href="#OSFA">Refer here</a>  -->
                <span style="font-size: 10px; white-space: pre-line; text-align: center;"></span>
              </div> 
            </div>
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #d8e3f3; border-color: #89a5ce; color: rgb(202, 53, 74);">
                <span style="font-size: 18px; margin-bottom: 20px; color: #121140; text-align: center;">PAIN POINTS</span> 
                <span style="font-size: 48px;color: #121140">{{ registerForm.assessorPOCs.length }}</span> 
                <!-- <a class="navlink" style="font-size: 14px; margin-bottom: 20px; text-align: center;" href="#POC">Refer here</a>  -->
                <span style="font-size: 10px; white-space: pre-line; text-align: center;"></span>
              </div> 
            </div>
            <div class="cardColumnBoxes">
              <div class="overviewCounterBox" style="background-color: #ffffff ; border-color: rgb(210, 220, 235); color: rgb(32, 149, 109);">
                <span style="font-size: 18px; margin-bottom: 20px;color: #121140; text-align: center;">PROPOSED SOLUTIONS</span> 
                <span style="font-size: 48px;color: #121140">{{ registerForm.assessorProjects.length }}</span> 
                <!-- <a class="navlink" style="font-size: 14px; margin-bottom: 20px; text-align: center;" href="#solutions">Refer here</a>  -->
                <span style="font-size: 10px; white-space: pre-line; text-align: center;"></span>
              </div>
            </div>
            <!-- <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; width: 100%; margin-top: 20px;"> -->  
            <!-- </div> -->
          </div> 
        </div>
      </div> 
      <el-form-item>
          <p section id="OSFA" class="cardTitleType1" style="font-weight: bold; font-size: 25px;">3. Onsite Smart Factory Assessment (OSFA) Findings</p>
        </el-form-item>
        <p></p>
        <p class="cardTitleType1" style="font-size: 16px; font-weight: bold; width: 100%;">3.1 Shift Factor - People</p>
        <p></p>
        <p class="cardTitleType1" style="font-size: 16px;">Remarks from Assessment Questions</p>
        <template>
          <el-table :data="peopleAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px; margin-bottom: 10px;">
            <!-- <el-table-column fixed prop="coreFactors" label="No." width="50" style="width: 100%; font-size: 15px;"/>
            <el-table-column prop="lowlights" label="Remarks from the assessment questions" width="600" />
            <el-table-column prop="lowlights" label="Action" width="150" /> -->
            <el-table-column
              align="center"
              prop="no"
              label="No."
              width="80">
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="no"
              label="Select to edit"
              width="80">
              <template slot-scope="scope">
                <el-checkbox :value="true" disabled style="justify-content: center;" />
              </template>
            </el-table-column> -->
            <el-table-column
              prop="assessorRemarks"
              label="Remarks from the assessment questions"
              width="800">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="registerForm[scope.row.assessorRemarks]" disabled/>
                <!-- <div width="600" v-for="(remark,index) in peopleAssessmentQuestionsRemarksTable" :key="index"> -->
                    <!-- <span>{{registerForm[scope.row.assessorRemarks]}}</span> -->
                <!-- </div> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
        <p class="cardTitleType1" style="font-size: 16px; font-weight: bold; width: 100%;">3.2 Shift Factor - Process</p>
        <p></p>
        <p></p>
        <p class="cardTitleType1" style="font-size: 16px;">Remarks from Assessment Questions </p>
        <template>
          <el-table :data="processAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px; margin-bottom: 10px;">
            <!-- <el-table-column fixed prop="coreFactors" label="No." width="50" style="width: 100%; font-size: 15px;"/>
            <el-table-column prop="lowlights" label="Remarks from the assessment questions" width="600" />
            <el-table-column prop="lowlights" label="Action" width="150" /> -->
            <el-table-column
              align="center"
              prop="no"
              label="No."
              width="80">
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="no"
              label="Select to edit"
              width="80">
              <template slot-scope="scope">
                <el-checkbox :value="true" disabled style="justify-content: center;" />
              </template>
            </el-table-column> -->
            <el-table-column
              prop="assessorRemarks"
              label="Remarks from the assessment questions"
              width="800">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="registerForm[scope.row.assessorRemarks]" disabled/>
                <!-- <div v-for="(remark,index) in processAssessmentQuestionsRemarksTable" :key="index"> -->
                    <!-- <span>{{registerForm[scope.row.assessorRemarks]}}</span> -->
                <!-- </div> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
        <p class="cardTitleType1" style="font-size: 16px; font-weight: bold; width: 100%;">3.3 Shift Factor - Technology</p>
        <p></p>
        <p></p>
        <p class="cardTitleType1" style="font-size: 16px;">Remarks from Assessment Questions </p>
        <template>
          <el-table :data="technologyAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px; margin-bottom: 10px;">
            <!-- <el-table-column fixed prop="coreFactors" label="No." width="50" style="width: 100%; font-size: 15px;"/>
            <el-table-column prop="lowlights" label="Remarks from the assessment questions" width="600" />
            <el-table-column prop="lowlights" label="Action" width="150" /> -->
            <el-table-column
              align="center"
              prop="no"
              label="No."
              width="80">
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="no"
              label="Select to edit"
              width="80">
              <template slot-scope="scope">
                <el-checkbox :value="true" disabled style="justify-content: center;" />
              </template>
            </el-table-column> -->
            <el-table-column
              prop="assessorRemarks"
              label="Remarks from the assessment questions"
              width="800">
              <template slot-scope="scope">
                <el-input type="textarea" v-model="registerForm[scope.row.assessorRemarks]" disabled/>
                <!-- <div v-for="(remark,index) in processAssessmentQuestionsRemarksTable" :key="index"> -->
                    <!-- <span>{{registerForm[scope.row.assessorRemarks]}}</span> -->
                <!-- </div> -->
              </template>
            </el-table-column>
          </el-table>
        </template>
      <!-- <div class="textContainerCenter"> -->  
      <!-- </div> -->
      <!-- <div class="graphContainer">
        <doughnut-chart style="width: 320px; height: 320px;" :chartData="doughnutData2" :options="doughnutOptions2"/>
      </div> --> 
      <!-- <p class="cardTitleType1" style="font-weight: bold; font-size: 25px; padding-top: 40px;">4. Self Assessment Results (as filled in by the company)</p>
      <div class="cardA4">
        <marks-diagram v-if="doughnutData" ref="customer_diagram" :doughnutData="doughnutData" />
        <div class="resultNeligibiltyDiv">
          <div style="margin: 30px 0px 10px 0px;">
            <h1 v-if="registerForm.assessmentDimensionResults && registerForm.assessmentDimensionResults.dimensionResultScore" style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">{{ registerForm.assessmentDimensionResults.dimensionResultScore | formatRound }}%</h1>
            <h1 v-else style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">0%</h1>
            <h3 style="font-weight: bold;">{{ registerForm.assessmentReadinessProfile && registerForm.assessmentReadinessProfile.readinessProfileTitle ? registerForm.assessmentReadinessProfile.readinessProfileTitle : 0 }}</h3>  
          </div>
          <div style="margin: 10px 0px 30px 0px;">
            <p style="text-align: justify;">{{ registerForm.assessmentReadinessProfile && registerForm.assessmentReadinessProfile.readinessProfileDescription ? registerForm.assessmentReadinessProfile.readinessProfileDescription : 0 }}</p>
          </div>
          <h3>The company's scores in the three shift factors are as follows:</h3>
          <div
            v-for="(assessmentDimensionGroup, key) in registerForm.assessmentDimensionGroups"
            :key="`assessmentDimensionGroupSeparate${key}`"
            style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; border-bottom: dotted 1px var(--darker-border-color);">
            <p style="display: flex; flex-direction: row; flex: 1;">{{ assessmentDimensionGroup.dimensionGroupLabel }}</p>
            <p style="display: flex; flex-direction: row; max-width: 100px; width: 100%; justify-content: flex-end; font-size: 1.15em;">{{ assessmentDimensionGroup.dimensionGroupScore | formatRound }}%</p>
          </div>
          <div style="margin: 20px 0px;">
          </div>
        </div>
      </div> -->
      <!-- <div class="textContainerCenter"> -->
        <!-- <title class="cardTitleType1">
          <span style="font-weight:bold; font-size: 22px; padding-top: 40px;">4. Onsite Assessment findings by the assessors</span>
        </title> -->
      <!-- </div> -->
      <!-- <div class="graphContainer">
        <doughnut-chart style="width: 320px; height: 320px;" :chartData="doughnutData3" :options="doughnutOptions3"/>
      </div> -->
      <!-- <div class="textContainerCenter"> -->
        <!-- <p style="margin: 5px;"></p>
        <p></p> -->
        <!-- <div
          style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; max-width: 720px; padding-top: 5px; padding-bottom: 5px;">
          <span v-if="registerForm.assessorAssessmentDimensionResults && registerForm.assessorAssessmentDimensionResults.dimensionResultScore" style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">{{ registerForm.assessorAssessmentDimensionResults.dimensionResultScore | formatRound }} % </span>
          <span v-else style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">0 % </span>
        </div> -->
        <!-- <div
          style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; max-width: 720px; padding-top: 5px; padding-bottom: 5px;">
          <span style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 20px; justify-content: center; align-items: flex-start;">{{ registerForm.assessorAssessmentReadinessProfile && registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle ? registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle : 0 }}</span>
        </div> -->
        <!-- <div
            style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; max-width: 720px; padding-top: 5px; padding-bottom: 5px;">
            <span style="display: flex; flex-direction: row; text-align:justify; width: 100%; font-weight: bolder; font-size: 20px;">{{ registerForm.assessorAssessmentReadinessProfile && registerForm.assessorAssessmentReadinessProfile.readinessProfileDescription ? registerForm.assessorAssessmentReadinessProfile.readinessProfileDescription : 0 }}</span>
        </div>
        <div style="font-size:20 px; display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; max-width: 720px; padding-top: 5px; padding-bottom: 5px;">
          <p> The company's scores in the three shift factors are as follows: </p>
        </div> -->
        <!-- <div
          v-for="(assessorAssessmentDimensionGroup, key) in registerForm.assessorAssessmentDimensionGroups"
          :key="`assessorAssessmentDimensionGroupSeparate${key}`"
          style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; max-width: 720px; padding-top: 5px; padding-bottom: 5px;">
          <span style="display: flex; flex-direction: row; flex: 1;">{{ assessorAssessmentDimensionGroup.dimensionGroupLabel }}</span>
          <!-- <span style="display: flex; flex-direction: row; max-width: 100px; width: 100%; font-size: 20px">{{ assessorAssessmentDimensionGroup.dimensionGroupTotal }}</span> -->
          <!-- <span style="display: flex; flex-direction: row; max-width: 140px; width: 100%; font-size: 20px">{{ assessorAssessmentDimensionGroup.dimensionGroupWeight }} %</span> -->
          <!-- <span style="display: flex; flex-direction: row; max-width: 100px; width: 100%; font-size: 20px">{{ assessorAssessmentDimensionGroup.dimensionGroupScore | formatRound }} %</span> -->
        <!-- </div> --> 
        <!-- <p style="display:inline;">Click <a href="detailedresult" target="_blank">HERE</a> for DETAILED SUMMARY and RECOMMENDATION.</p> -->
        <!-- <p></p> -->
          <!-- <div style="display: flex; flex-direction: row; margin-bottom: 10 px;"> -->
          <!-- <div class="submitButton">
            <el-button style="float: right;" v-loading="btnloading" type="primary" @click="()=>postsaveForm()">Submit</el-button>
          </div> -->
        <!-- </div> -->
      <!-- </div> -->
      <el-form-item>
        <p section id="OSFA" class="cardTitleType1" style="font-weight: bold; font-size: 25px;">4. Onsite Smart Factory Assessment (OSFA) Findings</p>
      </el-form-item>
      <house-graph 
      graphTitle="HIGHLIGHTS" 
      placeholderText="Highlight" 
      :graphTitleSmall='false' 
      :leadershipGraphData="leadershipGraphDataHighlights"
      :strategyGraphData="strategyGraphDataHighlights"
      :competencyGraphData="competencyGraphDataHighlights"
      :horizontalIntegrationGraphData="horizontalIntegrationGraphDataHighlights"
      :facilityGraphData="facilityGraphDataHighlights"
      :enterpriseGraphData="enterpriseGraphDataHighlights"
      :shopFloorGraphData="shopFloorGraphDataHighlights"
      :cybersecurityGraphData="cybersecurityGraphDataHighlights"
      :performanceGraphData="performanceGraphDataHighlights"
      :productionGraphData="productionGraphDataHighlights"
      :productGraphData="productGraphDataHighlights"
      />
      <house-graph graphTitle="AREAS OF IMPROVEMENT" 
      placeholderText="AOI/Lowlight" 
      :graphTitleSmall='true'
      :leadershipGraphData="leadershipGraphDataLowlights"
      :strategyGraphData="strategyGraphDataLowlights"
      :competencyGraphData="competencyGraphDataLowlights"
      :horizontalIntegrationGraphData="horizontalIntegrationGraphDataLowlights"
      :facilityGraphData="facilityGraphDataLowlights"
      :enterpriseGraphData="enterpriseGraphDataLowlights"
      :shopFloorGraphData="shopFloorGraphDataLowlights"
      :cybersecurityGraphData="cybersecurityGraphDataLowlights"
      :performanceGraphData="performanceGraphDataLowlights"
      :productionGraphData="productionGraphDataLowlights"
      :productGraphData="productGraphDataLowlights"
      />
      <!-- <p class="cardTitleType1" style="font-weight: bold;">4.1 Shift Factor - People</p>
      <p></p>
      <el-form-item style="font-size: 16px; font-style: italic;" label="*Please click on the checkbox of the remarks/highlights/areas of improvements that would be included in the reports and edit the remarks/highlights/areas of improvements if needed. Key in additional remarks/highlights/lowlights in the 'Insert additional remarks' colum. Click 'Save' at the end of the page to save the edited remarks/highlights/areas of improvements.*"></el-form-item>
      <p></p> -->
      <!-- <p class="cardTitleType1">A. Remarks from Assessment Questions</p> -->
      <!-- <template> -->
        <!-- <el-table :data="peopleAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px;"> -->
          <!-- <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="assessorRemarks"
            label="Remarks from the assessment questions"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="registerForm[scope.row.assessorRemarks]" :disabled="!scope.row.checked"/>
              <!-- <div width="600" v-for="(remark,index) in peopleAssessmentQuestionsRemarksTable" :key="index"> -->
                  <!-- <span>{{registerForm[scope.row.assessorRemarks]}}</span> -->
              <!-- </div> -->
            <!-- </template> -->
          <!-- </el-table-column> --> 
        <!-- </el-table> -->
      <!-- </template> -->
      <!-- <p></p> -->
      <!-- <p class="cardTitleType1">B. Highlights</p> -->
      <!-- <template> -->
        <!-- <el-table :data="peopleHighlightsTable" style="width: 100%; font-size: 15px;"> -->
          <!-- <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column> -->
          <!-- <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="findingDescription"
            label="Highlights"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column> -->
        <!-- </el-table> -->
      <!-- </template> -->
      <!-- <p></p>
      <p class="cardTitleType1" >C. Areas of Improvements</p> -->
      <!-- <template>
        <el-table :data="peopleLowlightsTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="findingDescription"
            label="Lowlights"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p></p>
      <p></p>
      <p class="cardTitleType1" style="font-weight: bold;">4.2 Shift Factor - Process</p>
      <p></p>
      <p></p> -->
      <!-- <p class="cardTitleType1">A. Remarks from Assessment Questions </p> -->
      <!-- <template>
        <el-table :data="processAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="assessorRemarks"
            label="Remarks from the assessment questions"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="registerForm[scope.row.assessorRemarks]" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p class="cardTitleType1">B. Highlights</p> -->
      <!-- <template>
        <el-table :data="processHighlightsTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="findingDescription"
            label="Highlights"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p></p>
      <p class="cardTitleType1">C. Areas of Improvements</p> -->
      <!-- <template>
        <el-table :data="processLowlightsTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="findingDescription"
            label="Areas Of Improvements"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p></p>
      <p></p>
      <p class="cardTitleType1" style="font-weight: bold; padding-top: 40 px;">4.3 Shift Factor - Technology</p>
      <p></p>
      <p></p>
      <p class="cardTitleType1">A. Remarks from Assessment Questions</p> -->
      <!-- <template>
        <el-table :data="technologyAssessmentQuestionsRemarksTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="assessorRemarks"
            label="Remarks from the assessment questions"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="registerForm[scope.row.assessorRemarks]" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p class="cardTitleType1"> B. Highlights </p> -->
      <!-- <template>
        <el-table :data="technologyHighlightsTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="No."
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="findingDescription"
            label="Highlights"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <!-- <p></p>
      <p class="cardTitleType1" style="margin-top: 50 px;"> C. Areas of Improvements</p> -->
      <!-- <template>
        <el-table :data="technologyLowlightsTable" style="width: 100%; font-size: 15px;">
          <el-table-column
            align="center"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="center"
            prop="no"
            label="Select to edit"
            width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" style="justify-content: center;" />
            </template>
          </el-table-column>
          <el-table-column
            prop="findingDescription"
            label="Areas Of Improvements"
            width="800">
            <template slot-scope="scope">
              <el-input v-model="scope.row.findingDescription" :disabled="!scope.row.checked"/>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading"> -->
        <!-- <p class="cardTitleType1" style="font-weight: bold;">Shift Factor - People</p> -->
        <!-- <el-form-item label="Highlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
              placeholder="Please select highlights related to the company"
              v-model="registerForm.assessorShiftFactorPeopleHighlightsCurrent">
              <el-option
                v-for="(item, key) in vmodelselectOptionsPeopleHighlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleHighlights')">Add</el-button>
          </div>
        </el-form-item> -->
      <!-- </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <el-form-item label="Lowlights">
          <div v-for="(assessorShiftFactorPeopleLowlight, key) in registerForm.assessorShiftFactorPeopleLowlights" :key="`assessorShiftFactorPeopleLowlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleLowlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleLowlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
              placeholder="Please select areas of improvements related the company"
              v-model="registerForm.assessorShiftFactorPeopleLowlightsCurrent">
              <el-option
                v-for="(item, key) in vmodelselectOptionsPeopleLowlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <p></p>
        <p class="cardTitleType1" style="font-weight: bold;">Shift Factor - Process </p>
        <el-form-item label="Operational Highlights">
          <div v-for="(assessorShiftFactorProcessOperationalHighlight, key) in registerForm.assessorShiftFactorProcessOperationalHighlights" :key="`assessorShiftFactorProcessOperationalHighlights${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorProcessOperationalHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorProcessOperationalHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select highlights related to the company"
            v-model="registerForm.assessorShiftFactorProcessOperationalHighlightsCurrent">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessHighlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorProcessOperationalHighlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <el-form-item label="Operational Lowlights">
          <div v-for="(assessorShiftFactorProcessOperationalLowlight, key) in registerForm.assessorShiftFactorProcessOperationalLowlights" :key="`assessorShiftFactorProcessOperationalLowlights${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorProcessOperationalLowlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorProcessOperationalLowlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select areas of improvements related the company"
            v-model="registerForm.assessorShiftFactorProcessOperationalLowlightsCurrent">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessLowlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorProcessOperationalLowlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <p></p>
        <el-form-item label="Product Highlights">
          <div v-for="(assessorShiftFactorProcessProductHighlight, key) in registerForm.assessorShiftFactorProcessProductHighlights" :key="`assessorShiftFactorProcessProductHighlights${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorProcessProductHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorProcessProductHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select highlights related to the company"
            v-model="registerForm.assessorShiftFactorProcessProductHighlightsCurrent" style="font-size: 18 px;">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessHighlights2"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorProcessProductHighlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <el-form-item label="Product Lowlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select areas of improvements related to the company"
            v-model="registerForm.vmodelselectProcessLowlights2">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessLowlights2"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <p></p>
        <el-form-item label="Cybersecurity Highlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select highlights related to the company"
            v-model="registerForm.vmodelselectProcessHighlights3" style="font-size: 18 px;">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessHighlights3"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>  
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <el-form-item label="Cybersecurity Lowlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select areas of improvements related to the company"
            v-model="registerForm.vmodelselectProcessLowlights3">
              <el-option
                v-for="(item, key) in vmodelselectOptionsProcessLowlights3"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>  
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <p></p>
        <p class="cardTitleType1" style="font-weight: bold;">Shift Factor - Technology </p>
        <el-form-item label="Technology Highlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select highlights related to the company"
            v-model="registerForm.vmodelselectTechnologyHighlights">
              <el-option
                v-for="(item, key) in vmodelselectOptionsTechnologyHighlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <el-form-item label="Technology Lowlights">
          <div v-for="(assessorShiftFactorPeopleHighlight, key) in registerForm.assessorShiftFactorPeopleHighlights" :key="`assessorShiftFactorPeopleHighlight${key}`" style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
            <span>{{ assessorShiftFactorPeopleHighlight }}</span>
            <el-button @click="()=>removeRegisterFormArray('assessorShiftFactorPeopleHighlights', key)">Remove</el-button>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%;">
            <el-select
            placeholder="Please select areas of improvements related to the company"
            v-model="registerForm.vmodelselectTechnologyLowlights">
              <el-option
                v-for="(item, key) in vmodelselectOptionsTechnologyLowlights"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
              </el-option>
            </el-select>
            <el-button @click="()=>addRegisterFormArray('assessorShiftFactorPeopleLowlights')">Add</el-button>
          </div>
        </el-form-item>  
      </el-form> -->
      <el-form class="profileForm" ref="userData" style="width:100%;" v-loading="loading">
        <p section id="recommendations" class="cardTitleType1" style="font-weight:bold; font-size: 25px;">5. Recommendations</p>
        <!-- <div> 
          <img id="Roadmap" :src="roadmapSample" width="600" height="400" style="display: flex; flex-direction: row; width: 100%; object-fit: contain; margin-top: 20px; margin-bottom: 20px;">
        </div>
        <div>
          <img id="Roadmap" :src="roadmapSample" width="600" height="400" style="display: flex; flex-direction: row; width: 100%; object-fit: contain; margin-top: 20px; margin-bottom: 20px;">
        </div> -->
        <div class="el-button-mobile-container center">
          <div class="avatarViewer" :class="recommendationGraphDocument.mime === 'image/png' || recommendationGraphDocument.mime === 'image/jpeg' ? 'downloadable' : ''" @click="()=>handleGraphDocumentClick(recommendationGraphDocument)" v-for="(recommendationGraphDocument, key) in assessmentsubmissiongraphfileRecommendations" :key="`recommendationGraphDocument_${key}`">
            <div class="avatar" :class="recommendationGraphDocument.mime === 'application/pdf' ? 'extraheight' : ''">
              <img v-if="recommendationGraphDocument.mime === 'image/png' || recommendationGraphDocument.mime === 'image/jpeg'"  style="display: flex; width: 100%; height: 100%; object-fit: contain;" :src="recommendationGraphDocument.url">
              <iframe v-else-if="recommendationGraphDocument.mime === 'application/pdf'" :src="recommendationGraphDocument.url" style="display: flex; width: 100%; height: 100%; background-color: #000;"></iframe>
            </div>
            <a :href="recommendationGraphDocument.url" target="_blank" :download="recommendationGraphDocument.name"><el-button style="display: flex; position: absolute; right: 4px; bottom: 4px;;" type="primary" icon="el-icon-download">Download</el-button></a>
          </div>
        </div>
        <!-- <template>
          <el-table :data="assessorRecommendationsTable" style="width: 100%; font-size: 15px; margin-bottom: 40px;">
            <el-table-column
              align="center"
              prop="no"
              label="No."
              width="80">
            </el-table-column>
            <el-table-column
            label="Shift Factors"
            width="150">
            <template slot-scope="scope">
              <el-select
                placeholder="Select Shift Factor"
                v-model="registerForm.sfassessorRecommendations">
                  <el-option
                  v-for="(item, key) in sfassessorRecommendationsOptions"
                  :key="key"
                  :value="item.label"
                  :label="item.label"
                  >
                  {{ item.label }}
                  </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="assessorRecommendations"
            label="Recommendations"
            width="400">
            <template slot-scope="scope">
              <span>Recommendation</span>
              <el-input v-model="scope.row.assessorRecommendations"/>
              <span>Activity</span>
                <el-input v-model="scope.row.activity"/>
                <div width="300" v-for="(activity,index) in scope.row.activities" :key="index">
                  <span>{{activity.activityDescription}}</span>
                </div>
                <el-button type="secondary small" style="margin-top: 10px;" @click="handleAddActivity()">+ Add activity</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="Duration"
            width="285">
            <template slot-scope="scope">
              <span>Recommendation (duration)</span>
              <el-select
              placeholder="Recommendation duration"
              v-model="registerForm.assessorDuration">
                <el-option
                v-for="(item, key) in vmodelselectOptionsDuration"
                :key="key"
                :value="item.label"
                :label="item.label"
                >
                {{ item.label }}
                </el-option>
              </el-select>
              <span>Activity duration</span>
              <el-select
                placeholder="Activity (duration)"
                v-model="registerForm.activityDuration">
                  <el-option
                  v-for="(item, key) in vmodelselectOptionsActivityDuration"
                  :key="key"
                  :value="item.label"
                  :label="item.label"
                  >
                  {{ item.label }}
                  </el-option>
                </el-select>
                <el-button type="secondary small" style="margin-top: 10px;">+ Add activity duration</el-button>
            </template>
          </el-table-column>
          </el-table>
        </template>   -->
        <!-- <div class="el-button-mobile-container center">
          <el-button style="display: flex; flex-direction: row; justify-content: left;" v-loading="btnloading" type="secondary" @click="()=>handleAddNewRecommendation()">+ Add Recommendation </el-button>
        </div>
        <div class="el-button-mobile-container center">
          <el-button style="" v-loading="btnloading" type="primary" @click="()=>handleUploadRoadmap()">Upload Roadmap Diagram </el-button>
        </div> -->
        <div style="margin-bottom: 20px"></div>
        <p class="cardTitleType1" style="font-weight:bold; font-size: 25px;">6. Results Summary (Onsite Assessment findings by the assessors)</p>
        <div class="cardA4">
          <marks-diagram v-if="doughnutData3" ref="assessor_diagram" :doughnutData="doughnutData3" />
          <div class="resultNeligibiltyDiv">
            <div style="margin: 30px 0px 10px 0px;">
              <h1 v-if="registerForm.assessorAssessmentDimensionResults && registerForm.assessorAssessmentDimensionResults.dimensionResultScore" style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">{{ registerForm.assessorAssessmentDimensionResults.dimensionResultScore | formatRound }}%</h1>
              <h1 v-else style="display: flex; flex-direction: row; width: 100%; font-weight: bolder; font-size: 24px; justify-content: center; align-items: flex-start;">0%</h1>
              <h3 style="font-weight: bold;">{{ registerForm.assessorAssessmentReadinessProfile && registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle ? registerForm.assessorAssessmentReadinessProfile.readinessProfileTitle : 0 }}</h3> 
            </div>
            <div style="margin: 10px 0px 30px 0px;">
              <p style="text-align: justify;">{{ registerForm.assessorAssessmentReadinessProfile && registerForm.assessorAssessmentReadinessProfile.readinessProfileDescription ? registerForm.assessorAssessmentReadinessProfile.readinessProfileDescription : 0 }}</p>
            </div>
            <h3>The company's scores in the three shift factors are as follows:</h3>
            <div
            v-for="(assessorAssessmentDimensionGroup, key) in registerForm.assessorAssessmentDimensionGroups"
              :key="`assessorAssessmentDimensionGroupSeparate${key}`"
              style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; border-bottom: dotted 1px var(--darker-border-color);">
              <p style="display: flex; flex-direction: row; flex: 1;">{{ assessorAssessmentDimensionGroup.dimensionGroupLabel }}</p>
              <!-- <span style="display: flex; flex-direction: row; max-width: 100px; width: 100%; font-size: 20px">{{ assessorAssessmentDimensionGroup.dimensionGroupTotal }}</span> -->
              <!-- <span style="display: flex; flex-direction: row; max-width: 140px; width: 100%; font-size: 20px">{{ assessorAssessmentDimensionGroup.dimensionGroupWeight }} %</span> -->
              <p style="display: flex; flex-direction: row; max-width: 100px; width: 100%; justify-content: flex-end; font-size: 1.15em;">{{ assessorAssessmentDimensionGroup.dimensionGroupScore | formatRound }}%</p>
            </div>
            <div style="margin: 20px 0px;">
              <!-- <p>Click <a href="detailedresult" target="_blank">HERE</a> for DETAILED SUMMARY and RECOMMENDATION.</p> -->
            </div>
            <!-- <div
              v-for="(assessmentRecommendationSet, key) in registerForm.assessmentRecommendationSets"
              :key="`assessmentRecommendationSet${key}`"
              style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; width: 100%; padding-top: 5px; padding-bottom: 5px;">
              <span style="display: flex; flex-direction: row; width: 100%;">{{ assessmentRecommendationSet.recommendationStatement ? assessmentRecommendationSet.recommendationStatement : '-' }}</span>
            </div> -->
          </div>
        </div>
        <p section id="POC" class="cardTitleType1" style="font-weight:bold; font-size: 25px;">7. POC/ Project Identification</p>
        <template>
        <el-table :data="registerForm.assessorPOCs" style="width: 100%; font-size: 15px;" class="aligntop">
          <!-- <el-table-column fixed prop="coreFactors" label="No." width="50" style="width: 100%; font-size: 15px;"/>
          <el-table-column prop="lowlights" label="Remarks from the assessment questions" width="600" />
          <el-table-column prop="lowlights" label="Action" width="150" /> -->
          <el-table-column
            align="top"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="top"
            prop="painPoints"
            label="Pain Points"
            width="400">
            <template slot-scope="scope">
              <el-input 
              v-model="scope.row.painPoints"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea" disabled
              />
                <div v-for="(painPoint,index) in scope.row.painPoints" :key="index">
                  <span>{{ painPoint.painPoints }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="projects"
            label="Projects"
            width="390">
            <template slot-scope="scope">
              <el-input 
              v-model="scope.row.projects"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea" disabled
              />
                <div v-for="(project,index) in scope.row.projects" :key="index">
                  <span>{{ project.projects }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="estimatedCostings"
            label="Estimated Costings (RM)"
            width="160">
            <template slot-scope="scope">
              <el-input
              ref="estimatedCostingsProject"
              v-model="scope.row.estimatedCostings"
              @input="()=>handleCurrencyInput('estimatedCostingsProject')"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea" disabled
              />
                <div v-for="(estimatedCosting,index) in scope.row.estimatedCostings" :key="index">
                  <span>{{ estimatedCosting.estimatedCostings }}</span>
                </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="el-button-mobile-container">
            <p class="message" style="margin-left: 400px; margin-right: 40px; font-weight: bold;">Total Costing: RM {{ pocsCosting }}</p>
          </div>
        </template>
        <!-- <img id="POCDiagram" :src="pocDiagram" width="600" height="400" style="display: flex; flex-direction: row; width: 100%; object-fit: contain; margin-top: 20px; margin-bottom: 20px;"> -->
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding-top: 5px;" v-for="(file, filekey) in POCfiles" :key="filekey">
          <div class="avatarViewer" :class="file.mime === 'image/png' || file.mime === 'image/jpeg' ? 'downloadable' : ''" @click="()=>handleGraphDocumentClick(file)" :key="`pocfile_${key}`">
            <div class="avatar" :class="file.mime === 'application/pdf' ? 'extraheight' : ''">
              <img v-if="file.mime === 'image/png' || file.mime === 'image/jpeg'"  style="display: flex; width: 100%; height: 100%; object-fit: contain;" :src="file.url">
              <iframe v-else-if="file.mime === 'application/pdf'" :src="file.url" style="display: flex; width: 100%; height: 100%; background-color: #000;"></iframe>
            </div>
            <a :href="file.url" target="_blank" :download="file.name"><el-button style="display: flex; position: absolute; right: 4px; bottom: 4px;;" type="primary" icon="el-icon-download">Download</el-button></a>
          </div>
        </div>
        <el-form-item>
          <title section id="solutions" class="cardTitleType1"><span style="font-weight: bold; font-size: 25px;">8. Projects </span></title>
        </el-form-item>
        <template>
        <el-table :data="registerForm.assessorProjects" style="width: 100%; font-size: 15px; margin-bottom: 20px;">
          <el-table-column
            align="top"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="top"
            prop="projectName"
            label="Projects"
            width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectName" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
                <div v-for="(projectName,index) in scope.row.projectName" :key="index">
                  <span>{{ projectName.projectNames }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="projectDetails"
            label="Description/Details"
            width="170">
            <template slot-scope="scope">
              <el-input 
              v-model="scope.row.projectDetails"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled
              />
              <div v-for="(projectDetail,index) in scope.row.projectDetail" :key="index">
                <span>{{ projectDetail.projectDetails }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="projectImplementationArea"
            label="Implementation Area"
            width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectImplementationArea" style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
              <div v-for="(projectImplementationArea,index) in scope.row.projectImplementationArea" :key="index">
                <span>{{ projectImplementationArea.projectImplementationAreas }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="projectImprovement"
            label="Improvement or Impact"
            width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectImprovement"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled
              />
              <div v-for="(projectImprovement,index) in scope.row.projectImprovement" :key="index">
                <span>{{ projectImprovement.projectImprovements }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="projectCosting"
            label="Costing (RM)"
            width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.projectCosting" 
              @input="()=>handleCurrencyInput('projectCosting')"
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled />
                <div v-for="(projectCosting,index) in scope.row.projectCosting" :key="index">
                  <span>{{ projectCosting.projectCostings }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            label="Technology"
            width="180">
            <template slot-scope="scope">
              <el-select
                placeholder="Select"
                v-model="scope.row.projectSmartTech"
                disabled>
                  <el-option
                  v-for="(item, key) in smartTechnologyOptions"
                  :key="key"
                  :value="item.label"
                  :label="item.label"
                  >
                  {{ item.label }}
                  </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="el-button-mobile-container">
          <p class="message" style="margin: 10px 200px 10px 0px; font-weight: bold;">Project Costing: RM {{ projectsCosting }}</p>
        </div>
        </template>
        <!-- <div class="el-button-mobile-container center">
          <el-button style="display: flex; flex-direction: row; justify-content: left;" v-loading="btnloading" type="secondary" @click="()=>handleAddNewProject()">+ Add Project </el-button>
        </div> -->
        <el-form-item>
          <p section id="training" class="cardTitleType1" style="font-weight:bold; font-size: 25px;">9. Training </p>
        </el-form-item>
        <template>
        <el-table :data="registerForm.assessorTrainings" style="width: 100%; font-size: 15px; margin-bottom: 20px;">
          <el-table-column
            align="top"
            prop="no"
            label="#"
            width="80">
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingName"
            label="Training"
            width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingName" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled
              />
                <div v-for="(trainingName,index) in scope.row.trainingName" :key="index">
                  <span>{{ trainingName.trainingNames }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingDescription"
            label="Description"
            width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingDescription" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled
              />
                <div v-for="(trainingDescription,index) in scope.row.trainingDescription" :key="index">
                  <span>{{ trainingDescription.trainingDescriptions }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingObjective"
            label="Objective"
            width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingObjective" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
                <div v-for="(trainingObjective,index) in scope.row.trainingObjective" :key="index">
                  <span>{{ trainingObjective.trainingObjectives }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingDuration"
            label="Duration"
            width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingDuration" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
                <div v-for="(trainingDuration,index) in scope.row.trainingDuration" :key="index">
                  <span>{{ trainingDuration.trainingDurations }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingLocation"
            label="Location"
            width="125">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingLocation" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
                <div v-for="(trainingLocation,index) in scope.row.trainingLocation" :key="index">
                  <span>{{ trainingLocation.trainingLocations }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingAudience"
            label="Audience"
            width="125">
            <template slot-scope="scope">
              <el-input v-model="scope.row.trainingAudience" 
              style="width: 100%; margin-bottom: 10px;"
              :autosize="{ minRows: 4 }"
              type="textarea"
              disabled/>
                <div v-for="(trainingAudience,index) in scope.row.trainingAudience" :key="index">
                  <span>{{ trainingAudience.trainingAudiences }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            align="top"
            prop="trainingCosting"
            label="Costing (RM)"
            width="130">
            <template slot-scope="scope">
              <el-input
              :ref="`trainingCosting_${scope.$index}`" 
              v-model="scope.row.trainingCosting"
              @input="()=>handleCurrencyInput(`trainingCosting_${scope.$index}`, 'trainingCosting', scope.$index, 'assessorTrainings')"
              style="width: 100%; margin-bottom: 10px;"
              disabled
              />
            </template>
          </el-table-column>
        </el-table>
        <div class="el-button-mobile-container">
          <p class="message" style="margin: 10px 200px 10px 0px; font-weight: bold;">Training Costing: RM {{ trainingsCosting }}</p>
        </div>
        <div class="el-button-mobile-container">
          <p class="message" style="margin: 10px 40px 10px 0px; font-weight: bold;">Total Costing: RM {{ totalCosting }}</p>
        </div>
        </template>
        <div class="el-button-mobile-container" style="margin-top: 20px; display: flex; flex-direction: row;">
          <div class="el-button-mobile-container">
            <el-button style="float: right;" v-loading="btnloading" type="secondary" @click="()=>handleGenerateExport()">Export To PDF</el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import roadmapSample from '@/assets/RoadmapSample.png'
import pocDiagram from '@/assets/POCDiagramSample.png'
import alarmSound from '@/assets/casio-alarm-beep.mp3'
import axios from "axios";
import maybankimg from "@/assets/maybank-logo-png-transparent.png"
import {
  getProjects,
  createProjects,
  updateProjects,
  removeProjects,
  duplicateProjects
} from "@/api/sferaProjects";
import {
  selfAssessmentSubmissions,
  postsaveAssessmentSubmissions,
  payAssessmentSubmissions,
  submitAssessmentSubmissions,
  fpxPayAssessmentSubmissions,
  downloadOsfaDeclaration,
  assessorReportAssessmentSubmissions,
  acceptOSFAAssessmentSubmissions,
  getAssessmentSubmissionById
} from "@/api/sferaAssessmentSubmissions";
import {
  uploadAssessmentSubmissionDocumentFile,
  removeAssessmentSubmissionDocumentFile
} from "@/api/sferaAssessmentSubmissionDocumentFiles";
import ndaSample from '@/assets/nda-sample.pdf'
import { findProjectLeaders } from "@/api/sferaUsers";
import moment from "moment";
import DoughnutChart from "@/components/DoughnutChart"

export default {
  name: "profile",
  data() {
    return {
      maybankimg,
      loading: true,
      btnloading: false,
      formProgress: 0,
      registerForm: {
        userAgreement: [],
        username: '',
        email: '',
        password: '',
        confirmedpassword: '',
        needNDA: true,
        NDAAgreement:'',
        acknowledgementReceivedOSFAReport:[],
      },
      asssessmentStatus: '',
      currentAssessmentId: '',
      users: [],
      projectleaderOptions: [],
      owneraddresses: [],
      filteredUsers: [],
      assessmentsubmissiondocumentfiles: [],
      assessmentsubmissiongraphfileRecommendations: [],
      POCfiles: [],
      search: "",
      entryFilter: "",
      typeOptions: [
        { value: '', label: 'All' },
        { value: 'entry', label: 'Entrance' },
        { value: 'onlyRegister', label: 'Register' },
      ],
      projectleaderStatusOptions: [
        { value: '', label: '- Please select one -' },
        { value: 'bid', label: 'Bidding' },
        { value: 'ready', label: 'Ready' },
      ],
      paymentMethodOptions: [
        { value: '', label: '- Please select one -' },
        { value: 'fpx', label: 'FPX' },
        { value: 'proof', label: 'Proof of Payment' },
      ],
      userAgreementValues: [],
      userAgreement: [
        {
          label: ' I agree to undertake the Onsite Smart Factory Assessment.',
          value: 'agree1'
        },
        {
          label: ' I will provide full cooperation and allow SIRIM to conduct OSFA at my premises.',
          value: 'agree2'
        },
        {
          label: ' I understand that acceptance to Smart Tech Up program shall depend on OSFA rating.',
          value: 'agree3'
        },
        {
          label: 'I will make payment of RM8,000 for OSFA. I understand the payment is not refundable regardless the OSFA result.',
          value: 'agree4'
        },
        {
          label: 'By submitting this declaration, I have agreed to all terms and conditions as above.',
          value: 'agree5'
        }
        // {
        //   label: 'In return, the Final Report will be prepared by SIRIM and will be my full right.',
        //   value: 'agree6'
        // }
      ],
      needNDAOptions: [
        { 
          value: true, 
          label: 'Yes' 
        },
        { 
          value: false, 
          label: 'No' 
        }, 
      ],
      NDAagreementCheckbox: [],
      NDAAgreement: [
        {
          label: ' I have read the Non-Disclosure Agreement and agreed to the terms and conditions within the Agreement.',
          value: 'agreeNDA'
        },
      ],
      OSFAReportoptions: [
        {
          label: ' I acknowledge that I have viewed and received this OSFA Report.',
          value: 'receivedOSFAReport'
        },
      ],
      smartTechnologyOptions: [
        {
          label: 'Additive Manufacturing',
          value: 'Additive Manufacturing'
        },
        {
          label: 'Artificial Intelligence',
          value: 'Artificial Intelligence'
        },
        {
          label: 'Big Data Analytics',
          value: 'Big Data Analytics'
        },
        {
          label: 'Advanced Materials',
          value: 'Advanced Materials'
        },
        {
          label: 'Cybersecurity',
          value: 'Cybersecurity'
        },
        {
          label: 'Simulation',
          value: 'Simulation'
        },
        {
          label: 'Cloud Computing',
          value: 'Cloud Computing'
        },
        {
          label: 'Augmented Reality',
          value: 'Augmented Reality'
        },
        {
          label: 'Industrial Internet of Things (IIoT)',
          value: 'IIoT'
        },
        {
          label: 'Autonomous Robot',
          value: 'robot'
        },
        {
          label: 'System Integration',
          value: 'integration '
        },
      ],
      dateType: 'on',
      dates: '',
      dates2: '',
      times: '',
      times2: '',
      currId: "",
      currRow: null,
      currUser: {
        companyStatus: "",
        dmuStatus: "",
        assessorStatus: "",
        projectleaderStatus: "",
        crowdinnovatorStatus: "",
        assessorReport: "",
        projectleaderProposal: "",
        crowdinnovatorProposal: "",
        approvalStatus: "",
        status: "",
        projectleaderEnd: "",
        assessorEnd: "",
        dmuEnd: "",
        companyEnd: "",
        projectleaderId: null,
      },
      currUser2: {
        companyStatus: "",
        dmuStatus: "",
        assessorStatus: "",
        projectleaderStatus: "",
        crowdinnovatorStatus: "",
        assessorReport: "",
        projectleaderProposal: "",
        crowdinnovatorProposal: "",
        approvalStatus: "",
        status: "",
        projectleaderEnd: "",
        assessorEnd: "",
        dmuEnd: "",
        companyEnd: "",
        projectleaderId: null,
      },
      peopleAssessmentQuestionsRemarksTable: [
        {
          "no": 1,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ1Strategy",
        },
        {
          "no": 2,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ1Leadership",
        },
        {
          "no": 3,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ2",
        },
        {
          "no": 4,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ3",
        }
      ],
      processAssessmentQuestionsRemarksTable: [
        {
          "no": 1,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ4ProdMx",
        },
        {
          "no": 2,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ4PerfMx",
        },
        {
          "no": 3,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ4HorIntegration",
        },
        {
          "no": 4,
          "checked": false,
          "assessorRemarks": 'assessorRemarksQ12',
        },
        {
          "no": 5,
          "checked": false,
          "assessorRemarks": 'assessorRemarksQ13',
        }
      ],
      technologyAssessmentQuestionsRemarksTable: [
        {
          "no": 1,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ5",
        },
        {
          "no": 2,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ6",
        },
        {
          "no": 3,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ7",
        },
        {
          "no": 4,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ9",
        },
        {
          "no": 5,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ10",
        },
        {
          "no": 6,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ11",
        },
        {
          "no": 7,
          "checked": false,
          "assessorRemarks": "assessorRemarksQ8",
        },
      ],
      ndaFiles: [],
      paymentUrl: '',
      paymentFormData: {
        TransactionType: '',
        PymtMethod: '',
        ServiceID: '',
        PaymentID: '',
        OrderNumber: '',
        PaymentDesc: '',
        MerchantReturnURL: '',
        MerchantApprovalURL: '',
        MerchantUnApprovalURL: '',
        MerchantCallbackURL: '',
        Amount: '',
        CurrencyCode: '',
        CustIP: '',
        CustName: '',
        CustEmail: '',
        CustPhone: '',
        PageTimeout: '',
        HashValue: ''
      },
      agreementToOSFA: true,
      userCreate: false,
      userUpdate: false,
      userDelete: false,
      userNDA: false,
      usernameNDA: false,
      userNDADate: false, 
      userNDAtime: false,
      userOSFA: false,
      userDuplicate: false,
      createdAtSort: false,
      muted: true,
      alarmAudio: null,
      eghlMessage: '',
      eghlStatus: '',
      total: 0,
      page: 1,
      limit: 100,
      serviceName: process.env.SERVICE_NAME,
      assessmentsubmission: {},
      registerForm: {
        allInformationGivenIsAccurate: false,
        readAndAgreeToAllDeclarations: false,
      },
      userCreate2: false,
      doughnutData: {
        borderColor :'black',
        labels: ['People','Process', 'Technology',],
        datasets: [{
          data: [100,100,100],
          backgroundColor: [
            '#273E95',
            '#5379f1',
            '#909399'
          ]
        }]
      },
      doughnutData3: {
        borderColor :'black',
        labels: ['People','Process', 'Technology'],
        datasets: [{
          data: [100,100,100],
          backgroundColor: [
            '#22577a',
            '#38a3a5',
            '#57cc99',
          ]
        }]
      },
      pocDiagram,
      roadmapSample,
      ndaSample
    }
  },
  props: {
    nextBranch: {
      type: Function
    },
    assessmentsubmissionId: {
      type: String
    }
  },
  methods: {
    createdAFormat(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY HH:mm')
      }
      return '-'
    },
    indexMethod(index) {
      return index + 1 + (this.page - 1) * this.limit;
    },
    showUpdate(index, row) {
      this.currRow = row;
      this.currUser = {
        companyStatus: row.companyStatus,
        dmuStatus: row.dmuStatus,
        assessorStatus: row.assessorStatus,
        projectleaderStatus: row.projectleaderStatus,
        crowdinnovatorStatus: row.crowdinnovatorStatus,
        assessorReport: row.assessorReport,
        projectleaderProposal: row.projectleaderProposal,
        crowdinnovatorProposal: row.crowdinnovatorProposal,
        approvalStatus: row.approvalStatus,
        status: row.status,
        projectleaderEnd: row.projectleaderEnd,
        assessorEnd: row.assessorEnd,
        dmuEnd: row.dmuEnd,
        companyEnd: row.companyEnd,
        projectleaderId: row.projectleaderId,
      };
      this.currId = row._id;
      // this.currId = index;
      this.userUpdate = true;
      this.remoteMethod()
    },
    showDelete(index, row) {
      this.currId = row._id;
      // this.currId = index;
      this.userDelete = true;
    },
    showDuplicate(index, row) {
      this.currId = row._id
      this.userDuplicate = true;
    },
    getFiles(file) {
      console.log(file);
    },
    enableAgreementToOSFA() {
      this.agreementToOSFA = true
    },
    disableAgreementToOSFA() {
      this.agreementToOSFA = false
    },
    async handleGenerateExport(){
      this.loading = true
      try {
        const blob = await assessorReportAssessmentSubmissions(this.$store.state.app.branchSelected, this.assessmentsubmissionId)
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Assessment-Report-${this.registerForm.companyname.toUpperCase()}.pdf`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        console.log('exported')
        // this.fetchData()
      } catch (err) {
        console.log(err)
      }
      this.loading = false
    },
    resetForm() {
      this.currUser = {
        companyStatus: "",
        dmuStatus: "",
        assessorStatus: "",
        projectleaderStatus: "",
        crowdinnovatorStatus: "",
        assessorReport: "",
        projectleaderProposal: "",
        crowdinnovatorProposal: "",
        approvalStatus: "",
        status: "",
        projectleaderEnd: "",
        assessorEnd: "",
        dmuEnd: "",
        companyEnd: "",
        projectleaderId: null,
      };
      this.currUser2 = {
        companyStatus: "",
        dmuStatus: "",
        assessorStatus: "",
        projectleaderStatus: "",
        crowdinnovatorStatus: "",
        assessorReport: "",
        projectleaderProposal: "",
        crowdinnovatorProposal: "",
        approvalStatus: "",
        status: "",
        projectleaderEnd: "",
        assessorEnd: "",
        dmuEnd: "",
        companyEnd: "",
        projectleaderId: null,
      };
      this.userCreate = false;
      this.userUpdate = false;
      this.userDelete = false;
      this.userDuplicate = false;
      this.userCreate2 = false;
      this.userNDA = false;
      this.userOSFA = false;
    },
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleAgree()  {
      this.userCreate = true;
    },
    handleSignNDA()  {
      this.userNDA = true;
    },
    async onSubmit() {
      this.btnloading = true;
      const data = {
        agreeToOnsiteAssessmentFlag: true,
        needNDA: this.registerForm.needNDA,
      };
      try {
        await postsaveAssessmentSubmissions(this.$store.state.app.branchSelected, data);
        this.userCreate = false;
        this.fetchData();
      } catch (err) {
      }
      this.btnloading = false;
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/sfera/${webpage}`)
    },
    async navigateToResultRegister() {
        // if (this.registerForm.selfAsssessmentResultsPassed !== false) {
        this.$router.push(`/z/${this.$store.state.app.branchSelected}/sfera/applicant/selfassessmentsresult_register`)
        //}
      },
    uploadNDA() {
      if (!this.btnloading) {
        this.$refs.fileSelect2.click()
      }
    },
    async downloadNDA() {
      this.btnloading = true
      try {
        const resp = await downloadOsfaDeclaration({
          assessmentsubmission: this.assessmentsubmission
        })
        const blob = new Blob([resp], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `Non-Disclosure Agreement - ${this.assessmentsubmission.companyname}.pdf`
        link.click()
        URL.revokeObjectURL(link.href)
        this.$message({
          message: 'Download Successful',
          type: 'success',
          duration: 5 * 1000
        })
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false
    },
    async deleteNDA(document) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        await removeAssessmentSubmissionDocumentFile(this.$store.state.app.branchSelected, document._id)
        // this.noteupload = null
        loading.close()

        this.$message({
          message: 'Document successfully saved',
          type: 'success',
          duration: 5 * 1000
        })
        this.fetchData()
      } catch (err) {
        loading.close()
      }
    },
    uploadProofOfPayment() {
      if (!this.btnloading) {
        this.$refs.fileSelect.click()
      }
    },
    async deleteProofOfPaymentFile(document) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        paymentOnsiteAssessmentPaymentMethod: this.registerForm.paymentOnsiteAssessmentPaymentMethod
      };
      try {
        await postsaveAssessmentSubmissions(this.$store.state.app.branchSelected, data);
        await removeAssessmentSubmissionDocumentFile(this.$store.state.app.branchSelected, document._id)
        // this.noteupload = null
        loading.close()

        this.$message({
          message: 'Document successfully saved',
          type: 'success',
          duration: 5 * 1000
        })
        this.fetchData()
      } catch (err) {
        loading.close()
      }
    },
    async handlePay() {
      this.userCreate2 = true
    },
    async handleFPX() {
      this.btnloading = true;
      const data = {
        paymentOnsiteAssessmentPaymentMethod: this.registerForm.paymentOnsiteAssessmentPaymentMethod
      };
      try {
        await postsaveAssessmentSubmissions(this.$store.state.app.branchSelected, data);
        const resp = await fpxPayAssessmentSubmissions(this.$store.state.app.branchSelected);
        this.paymentUrl = resp.url
        this.paymentFormData = {
          TransactionType: resp.TransactionType,
          PymtMethod: resp.PymtMethod,
          ServiceID: resp.ServiceID,
          PaymentID: resp.PaymentID,
          OrderNumber: resp.OrderNumber,
          PaymentDesc: resp.PaymentDesc,
          MerchantReturnURL: resp.MerchantReturnURL,
          MerchantApprovalURL: resp.MerchantApprovalURL,
          MerchantUnApprovalURL: resp.MerchantUnApprovalURL,
          MerchantCallBackURL: resp.MerchantCallBackURL,
          Amount: resp.Amount,
          CurrencyCode: resp.CurrencyCode,
          CustIP: resp.CustIP,
          CustName: resp.CustName,
          CustEmail: resp.CustEmail,
          CustPhone: resp.CustPhone,
          PageTimeout: resp.PageTimeout,
          HashValue: resp.HashValue
        }
        this.$nextTick(() => {
          this.$refs.paymentForm.submit();
        })
        // update data to filteredUsers based on currId
        // this.filteredUsers.splice(this.currId, 1, data);
        await this.fetchData();
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false;
    },
    async onSubmit2() {
      this.btnloading = true;
      const data = {
        paymentOnsiteAssessmentPaymentMethod: this.registerForm.paymentOnsiteAssessmentPaymentMethod
      };
      try {
        await postsaveAssessmentSubmissions(this.$store.state.app.branchSelected, data);
        await payAssessmentSubmissions(this.$store.state.app.branchSelected);
        // update data to filteredUsers based on currId
        // this.filteredUsers.splice(this.currId, 1, data);
        this.userCreate2 = false;
        await this.fetchData();
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false;
    },
    async onSubmit3() {
      this.btnloading = true;
      try {
        await removeProjects(this.$store.state.app.branchSelected, this.currId);
        // remove data to filteredUsers based on currId
        // this.filteredUsers.splice(this.currId, 1);
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false;
      this.userDelete = false;
      await this.fetchData();
    },
    async onSubmit4() {
      this.btnloading = true;
      try {
        await duplicateProjects(this.$store.state.app.branchSelected, this.currId);
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false;
      this.userDuplicate = false;
      await this.fetchData();
    },
    async remoteMethod() {
      this.itemLoading = true
      try {
        const resp = await findProjectLeaders(this.$store.state.app.branchSelected)
        this.projectleaderOptions = resp.data
      } catch (err) {
        console.log(err)
      }
      this.itemLoading = false
    },
    playAlarmSound() {
      this.alarmAudio.play()
    },
    toggleMute() {
      this.muted = !this.muted
      if (!this.muted) {
        this.playAlarmSound()
      }
    },
    clear() {
      this.search = "";
      this.fetchData();
    },
    async fetchData() {
      this.loading = true
      try {
        const assessmentSubmission = await getAssessmentSubmissionById(this.$store.state.app.branchSelected, this.assessmentsubmissionId);
        this.assessmentsubmission = assessmentSubmission
        // console.log("assessmentSubmission._id", assessmentSubmission)
        this.currentAssessmentId = assessmentSubmission._id
        this.asssessmentStatus = assessmentSubmission.status
        this.ndaFiles = assessmentSubmission.assessmentsubmissiondocumentfiles.filter((v) => {
          return v.fileType === 'nda'
        }).map((file) => {
          return {
            ...file,
            url: `${process.env.BASE_API}/uploads/${file.hash}`
          }
        })
        // this.asssessmentStatus = 'draft'
        this.maxPage = 1
        this.currentPage = 0
        this.assessmentsubmissiondocumentfiles = assessmentSubmission.assessmentsubmissiondocumentfiles ? assessmentSubmission.assessmentsubmissiondocumentfiles.filter((v) => {
          return v.fileType === 'paymentProof'
        }).map((file) => {
          return {
            ...file,
            url: `${process.env.BASE_API}/uploads/${file.hash}`
          }
        }) : []
        this.assessmentsubmissiongraphfileRecommendations = assessmentSubmission.assessmentsubmissiongraphfiles ? assessmentSubmission.assessmentsubmissiongraphfiles.filter((v) => {
          return v.fileType === 'assessorRecommendations'
        }).map((file) => {
          return {
            ...file,
            url: `${process.env.BASE_API}/uploads/${file.hash}`
          }
        }) : []
        this.POCfiles = assessmentSubmission.assessmentsubmissiondocumentfiles ? assessmentSubmission.assessmentsubmissiondocumentfiles.filter((v) => {
          return v.fileType === 'assessorPOC'
        }).map((file) => {
          return {
            ...file,
            url: `${process.env.BASE_API}/uploads/${file.hash}`
          }
        }) : []
        this.registerForm = {
          companyname: assessmentSubmission.companyname ? assessmentSubmission.companyname : '',
          agreeToOnsiteAssessmentFlag: assessmentSubmission.agreeToOnsiteAssessmentFlag ? assessmentSubmission.agreeToOnsiteAssessmentFlag : false,
          dmuScreenFlag: assessmentSubmission.dmuScreenFlag ? assessmentSubmission.dmuScreenFlag : false,
          paymentOnsiteAssessmentPaymentMethod: assessmentSubmission.paymentOnsiteAssessmentPaymentMethod ? assessmentSubmission.paymentOnsiteAssessmentPaymentMethod : '',
          paymentOnsiteAssessmentStatus: assessmentSubmission.paymentOnsiteAssessmentStatus ? assessmentSubmission.paymentOnsiteAssessmentStatus : '',
          paymentOnsiteAssessmentFlag: assessmentSubmission.paymentOnsiteAssessmentFlag ? assessmentSubmission.paymentOnsiteAssessmentFlag : false,
          paymentOnsiteAssessmentDMURemarks: assessmentSubmission.paymentOnsiteAssessmentDMURemarks ? assessmentSubmission.paymentOnsiteAssessmentDMURemarks : '',
          paymentOnsiteAssessmentDMUDate: assessmentSubmission.paymentOnsiteAssessmentDMUDate ? assessmentSubmission.paymentOnsiteAssessmentDMUDate : '',
          status: assessmentSubmission.status ? assessmentSubmission.status : '',
          stage1DeclarationFlag: assessmentSubmission.stage1DeclarationFlag ? assessmentSubmission.stage1DeclarationFlag : false,
          stage2CompanyInformationFlag: assessmentSubmission.stage2CompanyInformationFlag ? assessmentSubmission.stage2CompanyInformationFlag : false,
          stage3SelfAssessmentFlag: assessmentSubmission.stage3SelfAssessmentFlag ? assessmentSubmission.stage3SelfAssessmentFlag : false,
          stage4ResultEligibilityFlag: assessmentSubmission.stage4ResultEligibilityFlag ? assessmentSubmission.stage4ResultEligibilityFlag : false,
          financialinsitutionChosenFlag: assessmentSubmission.financialinsitutionChosenFlag ? assessmentSubmission.financialinsitutionChosenFlag : false,
          selfAsssessmentResultsPassed: assessmentSubmission.selfAsssessmentResultsPassed === true ? true : assessmentSubmission.selfAsssessmentResultsPassed === false ? false : null,
          failAndAgreeOnsiteAssessmentFlag: assessmentSubmission.failAndAgreeOnsiteAssessmentFlag ? assessmentSubmission.failAndAgreeOnsiteAssessmentFlag : false,
          stage10DMUFinalReportFlag: assessmentSubmission.stage10DMUFinalReportFlag ? assessmentSubmission.stage10DMUFinalReportFlag : false,
          stage11AcceptOSFAReportFlag: assessmentSubmission.stage11AcceptOSFAReportFlag ? assessmentSubmission.stage11AcceptOSFAReportFlag : false,
        }
        if (assessmentSubmission.stage10DMUFinalReportFlag) {
          const answerData = assessmentSubmission.answerData
          this.maxPage = 1
          const assessorAssessmentDimensionGroups = {}
          const assessorAssessmentDimensions = assessmentSubmission.assessorAssessmentDimensions ? assessmentSubmission.assessorAssessmentDimensions : {}
          for (var assessorAssessmentDimensionGroup in assessmentSubmission.assessorAssessmentDimensionGroups) {
            assessorAssessmentDimensionGroups[assessorAssessmentDimensionGroup] = {
              ...assessmentSubmission.assessorAssessmentDimensionGroups[assessorAssessmentDimensionGroup],
              assessorAssessmentDimensions: []
            }
          }
          for (var dimensionKey in assessorAssessmentDimensions) {
            const assessorAssessmentDimension = assessorAssessmentDimensions[dimensionKey]
            const dimensionGroupKey = assessorAssessmentDimension.dimensionGroupKey
            if (dimensionGroupKey && assessorAssessmentDimensionGroups[dimensionGroupKey]) {
              assessorAssessmentDimensionGroups[dimensionGroupKey].assessorAssessmentDimensions = [
                ...assessorAssessmentDimensionGroups[dimensionGroupKey].assessorAssessmentDimensions,
                assessorAssessmentDimension
              ]
            }
          }
          this.registerForm = {
            ...this.registerForm,
            assessorRemarksQ1Strategy: assessmentSubmission.assessorRemarksQ1Strategy ? assessmentSubmission.assessorRemarksQ1Strategy : '',
            assessorRemarksQ1Leadership: assessmentSubmission.assessorRemarksQ1Leadership ? assessmentSubmission.assessorRemarksQ1Leadership : '',
            assessorRemarksQ2: assessmentSubmission.assessorRemarksQ2 ? assessmentSubmission.assessorRemarksQ2 : '',
            assessorRemarksQ3: assessmentSubmission.assessorRemarksQ3 ? assessmentSubmission.assessorRemarksQ3 : '',
            assessorRemarksQ4ProdMx: assessmentSubmission.assessorRemarksQ4ProdMx ? assessmentSubmission.assessorRemarksQ4ProdMx : '',
            assessorRemarksQ4PerfMx: assessmentSubmission.assessorRemarksQ4PerfMx ? assessmentSubmission.assessorRemarksQ4PerfMx : '',
            assessorRemarksQ4HorIntegration: assessmentSubmission.assessorRemarksQ4HorIntegration ? assessmentSubmission.assessorRemarksQ4HorIntegration : '',
            assessorRemarksQ5: assessmentSubmission.assessorRemarksQ5 ? assessmentSubmission.assessorRemarksQ5 : '',
            assessorRemarksQ6: assessmentSubmission.assessorRemarksQ6 ? assessmentSubmission.assessorRemarksQ6 : '',
            assessorRemarksQ7: assessmentSubmission.assessorRemarksQ7 ? assessmentSubmission.assessorRemarksQ7 : '',
            assessorRemarksQ8: assessmentSubmission.assessorRemarksQ8 ? assessmentSubmission.assessorRemarksQ8 : '',
            assessorRemarksQ9: assessmentSubmission.assessorRemarksQ9 ? assessmentSubmission.assessorRemarksQ9 : '',
            assessorRemarksQ10: assessmentSubmission.assessorRemarksQ10 ? assessmentSubmission.assessorRemarksQ10 : '',
            assessorRemarksQ11: assessmentSubmission.assessorRemarksQ11 ? assessmentSubmission.assessorRemarksQ11 : '',
            assessorRemarksQ12: assessmentSubmission.assessorRemarksQ12 ? assessmentSubmission.assessorRemarksQ12 : '',
            assessorRemarksQ13: assessmentSubmission.assessorRemarksQ13 ? assessmentSubmission.assessorRemarksQ13 : '',
            peopleRemarks: assessmentSubmission.peopleRemarks ? assessmentSubmission.peopleRemarks : '',
            processRemarks: assessmentSubmission.processRemarks ? assessmentSubmission.processRemarks : '',
            technologyRemarks: assessmentSubmission.technologyRemarks ? assessmentSubmission.technologyRemarks : '',
            companyname: assessmentSubmission.companyname ? assessmentSubmission.companyname : '',
            companyaddress: assessmentSubmission.companyaddress ? assessmentSubmission.companyaddress : '',
            factoryaddress: assessmentSubmission.factoryaddress ? assessmentSubmission.factoryaddress : '',
            establishmentyear: assessmentSubmission.establishmentyear ? assessmentSubmission.establishmentyear : '',
            contactpersonname: assessmentSubmission.contactpersonname ? assessmentSubmission.contactpersonname : '',
            contactpersonposition: assessmentSubmission.contactpersonposition ? assessmentSubmission.contactpersonposition : '',
            contactpersonsalutation: assessmentSubmission.contactpersonsalutation ? assessmentSubmission.contactpersonsalutation : '',
            telephone: assessmentSubmission.telephone ? assessmentSubmission.telephone : '',
            handphone: assessmentSubmission.handphone ? assessmentSubmission.handphone : '',
            fax: assessmentSubmission.fax ? assessmentSubmission.fax : '',
            email: assessmentSubmission.email ? assessmentSubmission.email : '',
            website: assessmentSubmission.website ? assessmentSubmission.website : '',
            industry_sector: assessmentSubmission.industry_sector ? assessmentSubmission.industry_sector : '',
            main_product_name: assessmentSubmission.main_product_name ? assessmentSubmission.main_product_name : '',
            product_focus: assessmentSubmission.product_focus ? assessmentSubmission.product_focus : '',
            employee: assessmentSubmission.employee ? assessmentSubmission.employee : '',
            // companynameRemarks: assessmentSubmission.companynameRemarks ? assessmentSubmission.companynameRemarks : '',
            // companyaddressRemarks: assessmentSubmission.companyaddressRemarks ? assessmentSubmission.companyaddressRemarks : '',
            // factoryaddressRemarks: assessmentSubmission.factoryaddressRemarks ? assessmentSubmission.factoryaddressRemarks : '',
            // establishmentyearRemarks: assessmentSubmission.establishmentyearRemarks ? assessmentSubmission.establishmentyearRemarks : '',
            // contactpersonnameRemarks: assessmentSubmission.contactpersonnameRemarks ? assessmentSubmission.contactpersonnameRemarks : '',
            // telephoneRemarks: assessmentSubmission.telephoneRemarks ? assessmentSubmission.telephoneRemarks : '',
            // handphoneRemarks: assessmentSubmission.handphoneRemarks ? assessmentSubmission.handphoneRemarks : '',
            // faxRemarks: assessmentSubmission.faxRemarks ? assessmentSubmission.faxRemarks : '',
            // emailRemarks: assessmentSubmission.emailRemarks ? assessmentSubmission.emailRemarks : '',
            // websiteRemarks: assessmentSubmission.websiteRemarks ? assessmentSubmission.websiteRemarks : '',
            // main_product_nameRemarks: assessmentSubmission.main_product_nameRemarks ? assessmentSubmission.main_product_nameRemarks : '',
            // employeeRemarks: assessmentSubmission.employeeRemarks ? assessmentSubmission.employeeRemarks : '',
            status: assessmentSubmission.status ? assessmentSubmission.status : '',
            assessorAssessmentCompletion: assessmentSubmission.assessorAssessmentCompletion ? assessmentSubmission.assessorAssessmentCompletion : '',
            assessorAssessmentDimensions: assessorAssessmentDimensions,
            assessorAssessmentDimensionGroups: assessorAssessmentDimensionGroups,
            assessorAssessmentDimensionResults: assessmentSubmission.assessorAssessmentDimensionResults ? assessmentSubmission.assessorAssessmentDimensionResults : {},
            assessorAssessmentRecommendationSets: assessmentSubmission.assessorAssessmentRecommendationSets ? assessmentSubmission.assessorAssessmentRecommendationSets : {},
            assessorAssessmentReadinessProfile: assessmentSubmission.assessorAssessmentReadinessProfile ? assessmentSubmission.assessorAssessmentReadinessProfile : {},
            assessorDuration: assessmentSubmission.assessorDuration ? assessmentSubmission.assessorDuration : '',
            assessorActivitiesPeople: assessmentSubmission.assessorActivitiesPeople ? assessmentSubmission.assessorActivitiesPeople : '',
            assessorActivitiesProcess: assessmentSubmission.assessorActivitiesProcess ? assessmentSubmission.assessorActivitiesProcess : '',
            assessorActivitiesTechnology: assessmentSubmission.assessorActivitiesTechnology ? assessmentSubmission.assessorActivitiesTechnology : '',
            assessorShiftFactorPeopleHighlights: assessmentSubmission.assessorShiftFactorPeopleHighlights ? assessmentSubmission.assessorShiftFactorPeopleHighlights : [],
            assessorShiftFactorPeopleLowlights: assessmentSubmission.assessorShiftFactorPeopleLowlights ? assessmentSubmission.assessorShiftFactorPeopleLowlights : '',
            assessorShiftFactorProcessOperationalHighlights: assessmentSubmission.assessorShiftFactorProcessOperationalHighlights ? assessmentSubmission.assessorShiftFactorProcessOperationalHighlights : [],
            assessorShiftFactorProcessOperationalLowlights: assessmentSubmission.assessorShiftFactorProcessOperationalLowlights ? assessmentSubmission.assessorShiftFactorProcessOperationalLowlights : '',
            assessorShiftFactorProcessProductHighlights: assessmentSubmission.assessorShiftFactorProcessProductHighlights ? assessmentSubmission.assessorShiftFactorProcessProductHighlights : [],
            assessorShiftFactorProcessProductLowlights: assessmentSubmission.assessorShiftFactorProcessProductLowlights ? assessmentSubmission.assessorShiftFactorProcessProductLowlights : '',
            assessorShiftFactorProcessCybersecurityHighlights: assessmentSubmission.assessorShiftFactorProcessCybersecurityHighlights ? assessmentSubmission.assessorShiftFactorProcessCybersecurityHighlights : [],
            assessorShiftFactorProcessCybersecurityLowlights: assessmentSubmission.assessorShiftFactorProcessCybersecurityLowlights ? assessmentSubmission.assessorShiftFactorProcessCybersecurityLowlights : '',
            assessorShiftFactorTechnologyHighlights: assessmentSubmission.assessorShiftFactorTechnologyHighlights ? assessmentSubmission.assessorShiftFactorTechnologyHighlights : [],
            assessorShiftFactorTechnologyLowlights: assessmentSubmission.assessorShiftFactorTechnologyLowlights ? assessmentSubmission.assessorShiftFactorTechnologyLowlights : '',
            assessorPOCs: assessmentSubmission.assessorPOCs ? assessmentSubmission.assessorPOCs : [],
            assessorProjects: assessmentSubmission.assessorProjects ? assessmentSubmission.assessorProjects : [],
            assessorTrainings: assessmentSubmission.assessorTrainings ? assessmentSubmission.assessorTrainings : [],
            peopleHighlightsTable: assessmentSubmission.peopleHighlightsTable && assessmentSubmission.peopleHighlightsTable.length !== 0 ? assessmentSubmission.peopleHighlightsTable : this.peopleHighlightsTable,
            peopleLowlightsTable: assessmentSubmission.peopleLowlightsTable && assessmentSubmission.peopleLowlightsTable.length !== 0 ? assessmentSubmission.peopleLowlightsTable : this.peopleLowlightsTable,
            processHighlightsTable: assessmentSubmission.processHighlightsTable && assessmentSubmission.processHighlightsTable.length !== 0 ? assessmentSubmission.processHighlightsTable : this.processHighlightsTable,
            processLowlightsTable: assessmentSubmission.processLowlightsTable && assessmentSubmission.processLowlightsTable.length !== 0 ? assessmentSubmission.processLowlightsTable : this.processLowlightsTable,
            technologyHighlightsTable: assessmentSubmission.technologyHighlightsTable && assessmentSubmission.technologyHighlightsTable.length !== 0 ? assessmentSubmission.technologyHighlightsTable : this.technologyHighlightsTable,
            technologyLowlightsTable: assessmentSubmission.technologyLowlightsTable && assessmentSubmission.technologyLowlightsTable.length !== 0 ? assessmentSubmission.technologyLowlightsTable : this.technologyLowlightsTable,
            assessorRecommendations: assessmentSubmission.assessorRecommendations ? assessmentSubmission.assessorRecommendations : [],
            assessorSmartTechnology: assessmentSubmission.assessorSmartTechnology ? assessmentSubmission.assessorSmartTechnology : [],
            assessmentDimensionResults: assessmentSubmission.assessmentDimensionResults ? assessmentSubmission.assessmentDimensionResults : {},
            assessmentReadinessProfile: assessmentSubmission.assessmentReadinessProfile ? assessmentSubmission.assessmentReadinessProfile : {},
            assessmentRecommendationSets: assessmentSubmission.assessmentRecommendationSets ? assessmentSubmission.assessmentRecommendationSets : {},
            assessmentDimensionGroups: assessmentSubmission.assessmentDimensionGroups ? assessmentSubmission.assessmentDimensionGroups : {},
            needNDA: assessmentSubmission.needNDA === true ? true : assessmentSubmission.needNDA === false ? false : null,
            acknowledgementReceivedOSFAReport: assessmentSubmission.acknowledgementReceivedOSFAReport ? assessmentSubmission.acknowledgementReceivedOSFAReport : [],
          }
          const previewReportDMUPassHistory = assessmentSubmission.previewReportDMUPassHistory ? assessmentSubmission.previewReportDMUPassHistory : []
          if (previewReportDMUPassHistory.length > 0) {
            const lastHistory = previewReportDMUPassHistory[previewReportDMUPassHistory.length - 1]
            this.latestPassedHistory = lastHistory
          } else {
            this.latestPassedHistory = {}
          }
          this.assessorRecommendations = assessmentSubmission.assessorRecommendations ? assessmentSubmission.assessorRecommendations : []
          const peopleHighlightsTable = this.registerForm.peopleHighlightsTable
          const peopleLowlightsTable = this.registerForm.peopleLowlightsTable
          const processHighlightsTable = this.registerForm.processHighlightsTable
          const processLowlightsTable = this.registerForm.processLowlightsTable
          const technologyHighlightsTable = this.registerForm.technologyHighlightsTable
          const technologyLowlightsTable = this.registerForm.technologyLowlightsTable
          this.leadershipGraphDataHighlights = peopleHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Leadership' && finding.checked
          })
          this.strategyGraphDataHighlights = peopleHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Smart Factory Strategy' && finding.checked
          })
          this.competencyGraphDataHighlights = peopleHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Competency' && finding.checked
          })
          this.facilityGraphDataHighlights = technologyHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Facility' && finding.checked
          })
          this.enterpriseGraphDataHighlights = technologyHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Enterprise' && finding.checked
          })
          this.shopFloorGraphDataHighlights = technologyHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Shop Floor' && finding.checked
          })
          this.horizontalIntegrationGraphDataHighlights = processHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Horizontal Integration' && finding.checked
          })
          this.cybersecurityGraphDataHighlights = processHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Cybersecurity' && finding.checked
          })
          this.performanceGraphDataHighlights = processHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Performance Management' && finding.checked
          })
          this.productionGraphDataHighlights = processHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Production Management' && finding.checked
          })
          this.productGraphDataHighlights = processHighlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Product' && finding.checked
          })
          
          this.leadershipGraphDataLowlights = peopleLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Leadership' && finding.checked
          })
          this.strategyGraphDataLowlights = peopleLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Smart Factory Strategy' && finding.checked
          })
          this.competencyGraphDataLowlights = peopleLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Competency' && finding.checked
          })
          this.facilityGraphDataLowlights = technologyLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Facility' && finding.checked
          })
          this.enterpriseGraphDataLowlights = technologyLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Enterprise' && finding.checked
          })
          this.shopFloorGraphDataLowlights = technologyLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Shop Floor' && finding.checked
          })
          this.horizontalIntegrationGraphDataLowlights = processLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Horizontal Integration' && finding.checked
          })
          this.cybersecurityGraphDataLowlights = processLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Cybersecurity' && finding.checked
          })
          this.performanceGraphDataLowlights = processLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Performance Management' && finding.checked
          })
          this.productionGraphDataLowlights = processLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Production Management' && finding.checked
          })
          this.productGraphDataLowlights = processLowlightsTable.filter((finding)=>{
            return finding.findingCoreFactor === 'Product' && finding.checked
          })
          // let formProgress = 0
          // if (assessmentSubmission.stage1DeclarationFlag) {
          //   formProgress += 20
          // }
          // if (assessmentSubmission.stage2CompanyInformationFlag) {
          //   formProgress += 20
          // }
          // if (assessmentSubmission.stage3SelfAssessmentFlag) {
          //   formProgress += 20
          // }
          // if (assessmentSubmission.stage4ResultEligibilityFlag) {
          //   formProgress += 20
          // }
          // if (assessmentSubmission.financialinsitutionChosenFlag) {
          //   formProgress += 20
          // }
          // this.formProgress = formProgress
          const dimensionScorePeople = assessmentSubmission.assessmentDimensionGroups && assessmentSubmission.assessmentDimensionGroups.thrustPeople && assessmentSubmission.assessmentDimensionGroups.thrustPeople.dimensionGroupScore ? Number(assessmentSubmission.assessmentDimensionGroups.thrustPeople.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0
          const dimensionScoreProcess = assessmentSubmission.assessmentDimensionGroups && assessmentSubmission.assessmentDimensionGroups.thrustProcess && assessmentSubmission.assessmentDimensionGroups.thrustProcess.dimensionGroupScore ? Number(assessmentSubmission.assessmentDimensionGroups.thrustProcess.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0
          const dimensionScoreTechnology = assessmentSubmission.assessmentDimensionGroups && assessmentSubmission.assessmentDimensionGroups.thrustTechnology && assessmentSubmission.assessmentDimensionGroups.thrustTechnology.dimensionGroupScore ? Number(assessmentSubmission.assessmentDimensionGroups.thrustTechnology.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0

          const chartDatalabel = []
          const chartDataset = []
          const chartDataBackgroundColor = []
          const chartDataFontColor = []
          const chartDataBorderColor = []
          const chartDataOffset = []

          chartDatalabel.push('People')
          chartDataset.push(dimensionScorePeople)
          chartDataBackgroundColor.push('#929DCF')
          chartDataFontColor.push('#ffffff')
          chartDataBorderColor.push('#000000')
          chartDataOffset.push(16)
          if (dimensionScorePeople < 14){
            chartDatalabel.push('')
            chartDataset.push(14 - dimensionScorePeople)
            chartDataBackgroundColor.push('#ffffff')
            chartDataFontColor.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor.push('#000000')
            chartDataOffset.push(16)
          }

          chartDatalabel.push('Process')
          chartDataset.push(dimensionScoreProcess)
          chartDataBackgroundColor.push('#E7C06D')
          chartDataFontColor.push('#ffffff')
          chartDataBorderColor.push('#000000')
          chartDataOffset.push(16)
          if (dimensionScoreProcess < 26){
            chartDatalabel.push('')
            chartDataset.push(26 - dimensionScoreProcess)
            chartDataBackgroundColor.push('#ffffff')
            chartDataFontColor.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor.push('#000000')
            chartDataOffset.push(16)
          }

          chartDatalabel.push('Technology')
          chartDataset.push(dimensionScoreTechnology)
          chartDataBackgroundColor.push('#D58185')
          chartDataFontColor.push('#ffffff')
          chartDataBorderColor.push('#000000')
          chartDataOffset.push(8)
          if (dimensionScoreTechnology < 60){
            chartDatalabel.push('')
            chartDataset.push(60 - dimensionScoreTechnology)
            chartDataBackgroundColor.push('#ffffff')
            chartDataFontColor.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor.push('#000000')
            chartDataOffset.push(8)
          }

          this.doughnutData = {
            labels: chartDatalabel,
            datasets: [{
              data: chartDataset,
              backgroundColor: chartDataBackgroundColor,
              fontColor: chartDataFontColor,
              borderColor: chartDataBorderColor,
              offset: chartDataOffset,
              borderWidth: 1,
            }]
          }

          const finalScore = assessmentSubmission.dimensionResultScoreSA ? assessmentSubmission.dimensionResultScoreSA : assessmentSubmission.assessmentDimensionResults && assessmentSubmission.assessmentDimensionResults.dimensionResultScore ? assessmentSubmission.assessmentDimensionResults.dimensionResultScore : 0
          this.finalScore = finalScore
          
          const dimensionScorePeople3 = assessmentSubmission.assessorAssessmentDimensionGroups && assessmentSubmission.assessorAssessmentDimensionGroups.thrustPeople && assessmentSubmission.assessorAssessmentDimensionGroups.thrustPeople.dimensionGroupScore ? Number(assessmentSubmission.assessorAssessmentDimensionGroups.thrustPeople.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0
          const dimensionScoreProcess3 = assessmentSubmission.assessorAssessmentDimensionGroups && assessmentSubmission.assessorAssessmentDimensionGroups.thrustProcess && assessmentSubmission.assessorAssessmentDimensionGroups.thrustProcess.dimensionGroupScore ? Number(assessmentSubmission.assessorAssessmentDimensionGroups.thrustProcess.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0
          const dimensionScoreTechnology3 = assessmentSubmission.assessorAssessmentDimensionGroups && assessmentSubmission.assessorAssessmentDimensionGroups.thrustTechnology && assessmentSubmission.assessorAssessmentDimensionGroups.thrustTechnology.dimensionGroupScore ? Number(assessmentSubmission.assessorAssessmentDimensionGroups.thrustTechnology.dimensionGroupScore).toLocaleString('en', { maximumFractionDigits: 0 }) : 0

          const chartDatalabel3 = []
          const chartDataset3 = []
          const chartDataBackgroundColor3 = []
          const chartDataFontColor3 = []
          const chartDataBorderColor3 = []
          const chartDataOffset3 = []

          chartDatalabel3.push('People')
          chartDataset3.push (dimensionScorePeople3)
          chartDataBackgroundColor3.push('#8AB0D9')
          chartDataFontColor3.push('#ffffff')
          chartDataBorderColor3.push('#000000')
          chartDataOffset3.push(16)
          if (dimensionScorePeople3 < 14){
            chartDatalabel3.push('')
            chartDataset3.push(14 - dimensionScorePeople3)
            chartDataBackgroundColor3.push('#ffffff')
            chartDataFontColor3.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor3.push('#000000')
            chartDataOffset3.push(16)
          }

          chartDatalabel3.push('Process')
          chartDataset3.push (dimensionScoreProcess3)
          chartDataBackgroundColor3.push('#FDD888')
          chartDataFontColor3.push('#ffffff')
          chartDataBorderColor3.push('#000000')
          chartDataOffset3.push(16)
          if (dimensionScoreProcess3 < 26){
            chartDatalabel3.push('')
            chartDataset3.push(26 - dimensionScoreProcess3)
            chartDataBackgroundColor3.push('#ffffff')
            chartDataFontColor3.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor3.push('#000000')
            chartDataOffset3.push(16)
          }

          chartDatalabel3.push('Technology')
          chartDataset3.push (dimensionScoreTechnology3)
          chartDataBackgroundColor3.push('#F3B2B6')
          chartDataFontColor3.push('#ffffff')
          chartDataBorderColor3.push('#000000')
          chartDataOffset3.push(8)
          if (dimensionScoreTechnology < 60){
            chartDatalabel3.push('')
            chartDataset3.push(60 - dimensionScoreTechnology3)
            chartDataBackgroundColor3.push('#ffffff')
            chartDataFontColor3.push('rgba(0, 0, 0, 0)')
            chartDataBorderColor3.push('#000000')
            chartDataOffset3.push(8)
          }

          this.doughnutData3 = {
            labels: chartDatalabel3,
            datasets: [{
              data: chartDataset3,
              backgroundColor: chartDataBackgroundColor3,
              fontColor: chartDataFontColor3,
              borderColor: chartDataBorderColor3,
              offset: chartDataOffset3,
              borderWidth: 1,
            }]
          }
          const finalScore3 = assessmentSubmission.dimensionResultScoreOSFA ? assessmentSubmission.dimensionResultScoreOSFA : assessmentSubmission.assessorAssessmentDimensionResults && assessmentSubmission.assessorAssessmentDimensionResults.dimensionResultScore ? assessmentSubmission.assessorAssessmentDimensionResults.dimensionResultScore : 0
          this.finalScore3 = finalScore3
        }
        console.log(this.registerForm)
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    async fileSelected(event) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        paymentOnsiteAssessmentPaymentMethod: this.registerForm.paymentOnsiteAssessmentPaymentMethod
      };
      try {
        const formData = new FormData()
        formData.append('file', event.target.files[0])
        formData.append('fileType', 'paymentProof')
        this.$refs.fileSelect.value = ''

        await postsaveAssessmentSubmissions(this.$store.state.app.branchSelected, data);
        await uploadAssessmentSubmissionDocumentFile(this.$store.state.app.branchSelected, formData)
        loading.close()
        this.$message({
          message: 'Upload successfully saved',
          type: 'success',
          duration: 5 * 1000
        })
        // this.$store.dispatch('GetInfo')
        this.fetchData()
      } catch (err) {
        loading.close()
      }
    },
    async fileSelected2(event) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const formData = new FormData()
        formData.append('file', event.target.files[0])
        formData.append('fileType', 'nda')
        this.$refs.fileSelect2.value = ''

        await uploadAssessmentSubmissionDocumentFile(this.$store.state.app.branchSelected, formData)
        loading.close()
        this.$message({
          message: 'Upload successfully saved',
          type: 'success',
          duration: 5 * 1000
        })
        // this.$store.dispatch('GetInfo')
        this.fetchData()
      } catch (err) {
        loading.close()
      }
    },
    handleOSFA() {
      this.userOSFA = true;
    },
    async acceptOSFAReport() {
      this.btnloading = true;
      try {
        await acceptOSFAAssessmentSubmissions(this.$store.state.app.branchSelected);
        // update data to filteredUsers based on currId
        // this.filteredUsers.splice(this.currId, 1, data);
        this.userOSFA = false;
        this.navigateToWebPage('applicant/company_projectapplication')
        // await this.fetchData();
      } catch (err) {
        console.error(err)
      }
      this.btnloading = false;
    },
    log(v) {
      console.log(v);
    }
  },
  filters: {
    formatRound(val) {
      return Math.round(val)
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatDateTime(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY HH:mm')
      }
      return '-'
    },
    statusFilter(val) {
      switch (val) {
        case 'confirm': {
          return 'Confirm'
        }
        case 'reject': {
          return 'Reject'
        }
        case 'pending': {
          return 'Pending'
        }
        case 'pass': {
          return 'Pass'
        }
        case 'fail': {
          return 'Fail'
        }
        case 'assign': {
          return 'Assign'
        }
        case 'complete': {
          return 'Complete'
        }
        case 'submit': {
          return 'Submit'
        }
        default: {
          return '-'
        }
      }
    }
  },
  watch: {
    entryFilter() {
      this.fetchData();
    }
  },
  computed: {
    paymentMethodDisable() {
      if (this.registerForm.paymentOnsiteAssessmentPaymentMethod === 'fpx') {
        return false
      } else if (this.registerForm.paymentOnsiteAssessmentPaymentMethod === 'proof' && this.assessmentsubmissiondocumentfiles.length > 0) {
        return false
      }
      return true
    },
    projectsCosting() {
      const totalCosting = this.registerForm.assessorProjects.reduce((acc, project) => {
        const newValue = project.projectCosting.replace(/,/g, '')
        return acc + Number(newValue)
      }, 0)
      return Number(totalCosting).toLocaleString('en', { maximumFractionDigits: 2 })
    },
    trainingsCosting() {
      const totalCosting = this.registerForm.assessorTrainings.reduce((acc, training) => {
        const newValue = training.trainingCosting ? training.trainingCosting.replace(/,/g, '') : '0'
        return acc + Number(newValue)
      }, 0)
      return Number(totalCosting).toLocaleString('en', { maximumFractionDigits: 2 })
    },
    trainingsCostingOverFlag() {
      const totalCosting = this.registerForm.assessorTrainings.reduce((acc, training) => {
        const newValue = training.trainingCosting ? training.trainingCosting.replace(/,/g, '') : '0'
        return acc + Number(newValue)
      }, 0)
      return Number(totalCosting) > 25000 ? true : false
    },
    totalCosting() {
      const projectsCosting = this.registerForm.assessorProjects.reduce((acc, project) => {
        const newValue = project.projectCosting ? project.projectCosting.replace(/,/g, '') : '0'
        return acc + Number(newValue)
      }, 0)
      const trainingsCosting = this.registerForm.assessorTrainings.reduce((acc, training) => {
        const newValue = training.trainingCosting ? training.trainingCosting.replace(/,/g, '') : '0'
        return acc + Number(newValue)
      }, 0)
      const totalCosting = projectsCosting + trainingsCosting
      return Number(totalCosting).toLocaleString('en', { maximumFractionDigits: 2 })
    },
    pocsCosting() {
      const totalCosting = this.registerForm.assessorPOCs.reduce((acc, poc) => {
        const newValue = poc.estimatedCostings.replace(/,/g, '')
        return acc + Number(newValue)
      }, 0)
      return Number(totalCosting).toLocaleString('en', { maximumFractionDigits: 2 })
    },
    userData() {
      return this.$store.state.user.userData;
    },
    awakRole() {
      return this.$store.state.user.awakRole;
    },
    companies() {
      return this.$store.state.user.companies;
    },
    token() {
      return this.$store.state.user.token;
    },
    branchId() {
      return this.$store.state.app.branchSelected;
    },
    outworkUrl() {
      return process.env.OUTWORK_URL;
    },
    branchRole() {
      return this.$store.state.user.branchData && this.$store.state.user.branchData.relation && this.$store.state.user.branchData.relation.role ? this.$store.state.user.branchData.relation.role : null
    },
    checkedHighlightsCount(){
      const leadershipGraphDataHighlightsCount = this.leadershipGraphDataHighlights ? this.leadershipGraphDataHighlights.length : 0
      const strategyGraphDataHighlightsCount = this.strategyGraphDataHighlights ? this.strategyGraphDataHighlights.length : 0
      const competencyGraphDataHighlightsCount = this.competencyGraphDataHighlights ? this.competencyGraphDataHighlights.length : 0
      const enterpriseGraphDataHighlightsCount = this.enterpriseGraphDataHighlights ? this.enterpriseGraphDataHighlights.length : 0
      const shopFloorGraphDataHighlightsCount = this.shopFloorGraphDataHighlights ? this.shopFloorGraphDataHighlights.length : 0
      const horizontalIntegrationGraphDataHighlightsCount = this.horizontalIntegrationGraphDataHighlights ? this.horizontalIntegrationGraphDataHighlights.length : 0
      const cybersecurityGraphDataHighlightsCount = this.cybersecurityGraphDataHighlights ? this.cybersecurityGraphDataHighlights.length : 0
      const performanceGraphDataHighlightsCount = this.performanceGraphDataHighlights ? this.performanceGraphDataHighlights.length : 0
      const productionGraphDataHighlightsCount = this.productionGraphDataHighlights ? this.productionGraphDataHighlights.length : 0
      const productGraphDataHighlightsCount = this.productGraphDataHighlights ? this.productGraphDataHighlights.length : 0
      return leadershipGraphDataHighlightsCount + strategyGraphDataHighlightsCount + competencyGraphDataHighlightsCount + enterpriseGraphDataHighlightsCount + shopFloorGraphDataHighlightsCount + horizontalIntegrationGraphDataHighlightsCount + cybersecurityGraphDataHighlightsCount + performanceGraphDataHighlightsCount + productionGraphDataHighlightsCount + productGraphDataHighlightsCount
    },
    checkedLowlightsCount(){
      const leadershipGraphDataLowlightsCount = this.leadershipGraphDataLowlights ? this.leadershipGraphDataLowlights.length : 0
      const strategyGraphDataLowlightsCount = this.strategyGraphDataLowlights ? this.strategyGraphDataLowlights.length : 0
      const competencyGraphDataLowlightsCount = this.competencyGraphDataLowlights ? this.competencyGraphDataLowlights.length : 0
      const enterpriseGraphDataLowlightsCount = this.enterpriseGraphDataLowlights ? this.enterpriseGraphDataLowlights.length : 0
      const shopFloorGraphDataLowlightsCount = this.shopFloorGraphDataLowlights ? this.shopFloorGraphDataLowlights.length : 0
      const horizontalIntegrationGraphDataLowlightsCount = this.horizontalIntegrationGraphDataLowlights ? this.horizontalIntegrationGraphDataLowlights.length : 0
      const cybersecurityGraphDataLowlightsCount = this.cybersecurityGraphDataLowlights ? this.cybersecurityGraphDataLowlights.length : 0
      const performanceGraphDataLowlightsCount = this.performanceGraphDataLowlights ? this.performanceGraphDataLowlights.length : 0
      const productionGraphDataLowlightsCount = this.productionGraphDataLowlights ? this.productionGraphDataLowlights.length : 0
      const productGraphDataLowlightsCount = this.productGraphDataLowlights ? this.productGraphDataLowlights.length : 0
      return leadershipGraphDataLowlightsCount + strategyGraphDataLowlightsCount + competencyGraphDataLowlightsCount + enterpriseGraphDataLowlightsCount + shopFloorGraphDataLowlightsCount + horizontalIntegrationGraphDataLowlightsCount + cybersecurityGraphDataLowlightsCount + performanceGraphDataLowlightsCount + productionGraphDataLowlightsCount + productGraphDataLowlightsCount
    },
  },
  components: {
    DoughnutChart
  },
  mounted() {
    this.fetchData();
    // this.$store.dispatch('DisableSidebarAllowed')
    this.$store.dispatch('EnableSidebarAllowed')
    if (this.$router.currentRoute.query.message) {
      this.eghlMessage = this.$router.currentRoute.query.message === 'Buyer cancelled' ? '' : this.$router.currentRoute.query.message
      this.eghlStatus = this.$router.currentRoute.query.status === 'success' ? 'success' : 'danger'
    }
  },
  beforeDestroy() {
  }
};
</script>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

.profileClass {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  background-color: $color2;
  width: 50%;
  padding: 10px;
}

.cardList {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
    p {
      margin: 0px;
    }
    .cardHeader {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .cardBody {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .cardField {
        font-weight: bold;
      }
      .cardValue {
        font-size: 14px; 
        font-weight: 100; 
        word-break: break-word; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
        margin-bottom: 30px;
      }
      .cardValue2 {
        display: flex;
        font-size: 10px;
      }
    }
  }
}

.el-select-dropdown__item {
  font-size: 11px;
}

.pagination-container {
  margin-top: 10px;
}

/* The property that resizes the card content */
.cardContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // max-width:  900px;
  min-width: 0px;
  margin: 0px 0px 0px 0px;
  padding: 0px 20px 0px 20px;
  overflow: hidden;
  // @media (max-width: 768px){
  //   max-width: 100%;
  // }
  // @media (max-width: 463px){
  //   padding: 0px 10px 0px 10px;
  // }
  .textContainerMessage {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0px 20px 20px 20px;
  }
  h1.message {
    font-size: 20px;
    margin: 0px 0px 10px 0px;
    font-weight: normal;
    text-align: center;
  }
  p.message {
    font-size: 16px;
    margin: 0px;
    text-align: center;
  }
  .questionHyperlink {
    font-size: 16px;
    margin: 0px;
    text-align: center;
    cursor: pointer; 
    font-style: italic; 
    color: #3379e3;
    transition: 0.2s;
  }
  .questionHyperlink:hover {
    text-decoration: underline;
  }
}
</style>

<style lang="scss" scoped>
@import "src/styles/variables.scss";

.profileClass {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  background-color: $color2;
  width: 50%;
  padding: 10px;
}

.cardList {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
    p {
      margin: 0px;
    }
    .cardHeader {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .cardBody {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      .cardField {
        font-weight: bold;
      }
      .cardValue {
        font-size: 14px; 
        font-weight: 100; 
        word-break: break-word; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
        margin-bottom: 30px;
      }
      .cardValue2 {
        display: flex;
        font-size: 10px;
      }
    }
  }
}




a {
  color: #2D9BF0;
  font-weight: 500;
  text-decoration: underline;
  display: inline;
}

.el-select-dropdown__item {
  font-size: 15px;
}

.el-select {
  display: inline;
}

.pagination-container {
  margin-top: 10px;
}

.avatarViewer {
  display: flex;
  width: 100%;
  max-width: 520px;
  margin-top: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  .avatar {
    width: 100%;
    height: 100%;
    // max-width: 320px;
    // min-width: 178px;
    // max-height: 320px;
    // min-height: 178px;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar.extraheight {
    height: 520px;
  }
}
</style>

<style lang="scss">
/* Column Organiser for Card Columns */
.cardOrganiser {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  flex-wrap: wrap;
  overflow: hidden;
}

.pageContainer {
  // flex-direction: row;
  // @media (max-width: 790px){
  //   flex-direction: row-reverse;
  //   flex-wrap: wrap-reverse;
  // }
  flex-wrap: wrap-reverse;
}

.el-date-editor .el-range-separator {
  width: auto;
}
.selectBackground {
  .el-input__inner {
    // background-color: var(--bg4-color);
    background-color: transparent;
  }
}

.el-card .el-card__header {
  width: 50%;
  padding: 8px 8px;
  margin: 0px 8px 8px 8px;
  border-bottom-color: var(--secondary1-active-color);
}

.el-card .el-card__body {
  padding: 8px 16px;
}



.suffix-remove {
  input.el-input__inner {
    padding-right: 0px;
  }
}
.expandRowFormContainer {
  display: flex;
  width: 100%;
  height: 120px;
  background-color: var(--bg-color);
  padding: 10px;
}
.expandRowForm {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  flex-wrap: wrap;
  width: 580px;
  .el-form-item {
    display: flex;
    flex-direction: column;
    width: 140px;
  }
  .el-form-item__label {
    text-align: left;
    width: 100%;
    // font-size: 11px;
    line-height: 18px;
  }
  .el-form-item__content {
    text-align: left;
    width: 100%;
    // font-size: 11px;
    line-height: 18px;
  }
}

.alarmDiv2 {
  display: flex;
  position: fixed;
  z-index: 1010;
  bottom: 100px;
  right: 20px;
  width: 84px;
  height: 84px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .muteButton {
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.2s;
    font-size: 50px;
  }
  .muteButton.muted {
    color: var(--beigeToGray);
  }
  .muteButton.unmuted {
    color: var(--primary5-color);
  }
}

.labelDisabled {
  .el-form-item__label {
    color: #858585;
  }
}

.columnmxw {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100%;
  min-width: 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.columnmxw.w20 {
  max-width: 30%;
}
.columnmxw.w20.remarks {
  max-width: 40%;
  
}
.columnmxw.w60 {
  max-width: 40%;
  border-left: 1px var(--darker-border-color) solid;
}

.loanApprovalContainer {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 0px;
  margin-bottom: 30px;
  padding-top: 0px;
  // padding-left: 200px;
  // padding-right: 200px;
  .loanApprovalButtonContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0px;
  }
  title {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
}

.graphContainer {
  display: flex;
  position: relative;
  margin-top: 30px;
  margin-bottom: 0px;
  width: 100%;
  justify-content: center;
}


.el-checkbox-group {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  line-height: 1px;
  .el-checkbox {
    line-height: 12px;
  }
  .el-checkbox__label {
    font-size: 16px;
    line-height: 16px;
    word-break: break-word; 
    white-space: nowrap; 
    overflow: hidden; 
    text-wrap: wrap;
  }
  .el-checkbox__inner {
    border-color: var(--darker-border-color);
    margin-bottom: 0px;
  }
  .el-checkbox__input {
    vertical-align: center;
    margin-bottom: 0px;
    position: absolute;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    width: 100%;
    word-wrap: break-word;
    word-break: keep-all;
    overflow: hidden;
    color: var(--v4-login-button-mid);
    margin-bottom: 0px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--v4-login-button-mid);
    border-color: var(--v4-login-button-mid);
    margin-bottom: 0px;
    position: absolute;
  }
  .el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: #C0C4CC;
  }
}
.draftButton {
  .el-button {
    color: var(--v4-dark-font-color);
    font-weight: 300;
    font-size: 15px;
    border-radius: 5px;
    padding: 15px 60px;
    background-color: var(--el-button);
    border-top: solid 2px var(--el-button-lightest);
    border-left: solid 2px var(--el-button-light);
    border-bottom: solid 2px var(--el-button-darkest);
    border-right: solid 2px var(--el-button-dark);
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .el-button:hover {
    background-color: var(--el-button-mid);
    border-top: solid 4px var(--el-button-lightest);
    border-bottom: solid 0px var(--el-button-darkest);
  }
  }
  .navlink {
  display: block;
  color: #FFFFFF;
  text-decoration: underline;
  background: none;
  border: 0;
  &:hover,
  &:focus {
    color: #858585;
    text-decoration: underline;
  }
}

    



// .el-table__expanded-cell[class*=cell] {
//   padding: 20px 50px;
// }
</style>


// WEBPACK FOOTER //
// src/views/sfera/components/OsfaReport.vue